import React from 'react';
import moment from 'moment';
import TapSelect from '../../../components/ui/TapSelect';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';
import swal from "sweetalert";
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import DatePicker from "react-datepicker";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2, ISC_API_BASE_URL_2, ISC_INV_TRANSFER_URL } from '../../../services/TapApiUrls';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import AddItemModal from '../../items/itemsAdd/AddItemModal';
import ItemEditModal from '../../items/itemsAdd/ItemEditModal';
import WarehouseAddress from '../includes/WarehouseAddress';
import { Helmet } from 'react-helmet';
import ItemSearchModal from '../../items/itemSearchModal';
import { Link } from 'react-router-dom';
import ItemViewInList from '../includes/ItemViewInList';
import NumberFormatter from '../../../services/NumberFormater';
import ChangeWarehouseAddressModal from './ChangeWarehouseAddressModal';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import InwardHistoryModal from '../includes/InwardHistoryModal';
import download from '../../../services/DownloadFile';
import api from '../../../services/api';
import AdditionalAttributeForm from '../../includes/ui/AdditionalAttributeForm';
import CurrencyService from '../../../services/CurrencyService';
import { DisplayListPagination } from '../../../components/TapUi';

class InventoryTransferAdd extends AppBaseComponent {

    constructor(props) {
        super(props);
         
        this.initITForm             =   {
            transaction_id              :   '',
            transaction_date            :   moment(new Date(),'YYYY-MM-DD').format('YYYY-MM-DD'),
            warehouse_from              :   null,
            warehouse_to                :   null,
            invoice_number              :   '',
            invoice_date                :   '',
            eway_number                 :   '',
            eway_date                   :   '',
            document_number             :   '',
            document_date               :   '',
            transporter_number          :   '',
            notes                       :   '',
            status                      :   '',
            adjustment_amount           :   0.0,
            vechicle_registration_no    :   '',
            no_of_boxes                 :   '',
            weight                      :   '',
            unit_of_weight              :   '',
            fullfill_purchase_qty       :   'N',
            date_of_dispatch            :   '',
            date_of_receive             :   '',
        }

        this.iniitTransferItemRow   =   {
            item                            :   null,
            stock_id                        :   null,
            remark                          :   '',
            amount                          :   0,
            qty                             :   0,
            stock_qty                       :   0,
            free_qty                        :   0,
            rate                            :   0,
            current_stocks                  :   [],
            selected_stock                  :   null,
            stock_loading                   :   false,
            allApiCallsCompleted            :   false,
        };

         this.iniitTransferItemRows   =   [this.iniitTransferItemRow];

        this.state                              =     {
            saveFormSubmitting                  :     false,
            inventoryTransferItemRows           :     [...this.iniitTransferItemRows],
            addInventoryTransferForm            :     {...this.initITForm},
            allDispatchingWarehouses            :     [],
            allReceivingWarehouses              :     [],
            isInitialEditLoading: false,
            allStatus                           :     [],
            allGstSlabs                         :     [],
            itemSearchedDetails                 :     null,
            itemRowNumber                       :      0,
            isc_configuration                   :     {},
            track_batch_expiry                  :    'N',
            negative_stock                      :     'N',
            formDataLoaded                      :     false,
            dispatchingWarehouseDetail          :     null,
            dispatchingWarehouseDetailLoading   :     false,
            receivingWarehouseDetail            :     null,
            receivingWarehouseDetailLoading     :     false,
            gstTypeName                         :     'GST',
            inventoryData                       :     null,
            userStatus                          :     [],
            selectedItemData                    :      null,
            selectedItemStocks                  :      [],
            selectedItemRow                     :       0,
            approved_indent_listing             :       false,
            indent_listing                      :       [],
            indnetListingMeta                   :       null,
            totalIndentListingCount             :       0,
            indentDetail                        :       null,
            indentTransId                       :       '',
            indent_detail_loading               :       false,
            only_stocked_item               :    'Y',
            allWeightUnits                  :       [{value:"gm",label:"Gram"},{value:"kg",label:"KilloGram"},{value:"tonne",label:"Tonne"}],
            indent_transaction_id           :           '',
            editInventoryTransfer           :       false,
            loading_item                    :       false,
            listingLoaded                   :       false,
            buttonDisabled                  :       true,
            sameDispatchWarehouseAddress    :   null,
            selectDispatchAddress           :   null,
            sameReceivingWarehouseAddress   :   null,
            selectReceivingAddress          :   null,
            dispatchAddressModalHandle      :   false,
            receivingAddressModalHandle     :   false,
            showItemSearchModal             :       false,
            showItemAddModal                :       false,
            showItemEditModal               :       false,
            loadingEditItems                 :       false,
            fromVoucher                     :       false,
            formData                        :   null,
            additionalAttributesData        :   {},
            receivingWarehouseAddressList   : [],
            receivingWarehouseListingMeta   : null,
            totalReceivingAddressCount      : 0,
            searchReceivingWarehouseAddress : "",
            receiving_address_loading       : false,
            selectedShippingAddress         : null,
            receiving_address_id            : null,
            shipping_address_id             : null,
            
        }
        this.addItemModalRef            =   React.createRef();
        this.editItemModalRef           =   React.createRef();
        this.itemSearchRef              =   React.createRef();
        this.changeWarehouseAddressRef  =   React.createRef();
        this.itemDetailsRef             =   React.createRef();
        this.inwardHistoryRef           =   React.createRef();
        this.addReceivingWarehouseAddressRef = React.createRef();
        
        this.warehouseShipAddUrl = INVENTORY_API_BASE_URL_2 + "/warehouse/shipping_address";
        this.warehouseIndentItemWiseUrl     =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/item_wise';
        this.warehouseIndentItemDetailUrl   =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/item_detail';
        this.detailUrl                      =   INVENTORY_API_BASE_URL_2 + '/warehouse_indent/detail';
        this.purchaseReportUrl              =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase';
        this.inventoryTransferUrl           =   INVENTORY_API_BASE_URL_2 + '/inventory_transfer';
        this.warehouseUrl                   =   ISC_API_BASE_URL_2  + '/warehouse';
        this.vendorUrl                      =   INVENTORY_API_BASE_URL_2 + '/vendor';
        this.itemUrl                        =   INVENTORY_API_BASE_URL_2 + '/item';
        this.itemsUrl                       =   INVENTORY_API_BASE_URL_2 + '/items';
        this.itemCurrentStockUrl            =   INVENTORY_API_BASE_URL_2 + '/item_current_stock';

    }

    componentDidMount() {
        if (this.props.all_warehouses.length  > 0) {

        this.initilaizeFormData(this.props) }


        this.transferBulkUploadModal = new Modal( document.getElementById("transferBulkUploadModal"),  { keyboard: false, backdrop: false });
        this.selectItemBatchModal      =   new Modal(document.getElementById('selectItemBatchModal'), {keyboard: false, backdrop :false});
        this.pickIndentItemModal      =   new Modal(document.getElementById('pickIndentItemModal'), {keyboard: false, backdrop :false});
        this.viewIndentDetailModal      =   new Modal(document.getElementById('viewIndentDetailModal'), {keyboard: false, backdrop :false});
        this.receivingWarehouseAddressModal      =   new Modal(document.getElementById('receivingWarehouseAddressModal'), {keyboard: false, backdrop :false});
    }

    componentWillReceiveProps(nextProps){
        if(this.props.location && this.props.location.state){
            if(nextProps.all_warehouses !== this.props.all_warehouses) {
                this.initilaizeFormData(nextProps);
            }
        }        
    }
    
    initilaizeFormData = (props) => {
        if (!this.state.formDataLoaded) {
            HttpAPICall.withAthorization('GET', this.inventoryTransferUrl + '/add_form_data', this.props.access_token, null, null, (response) => {
                let formData = response.data;
                this.setState({
                    formDataLoaded: formData ? true : false,
                     formData: formData,
                    allDispatchingWarehouses: props.all_warehouses ? props.all_warehouses.map((s) => { return { value: s.id, label: `${s.name} (${s.code})`, site_id: s.site_id }; }) : [],
                    allReceivingWarehouses: formData && formData.warehouses ? formData.warehouses.map((s) => { return { value: s.id, label: `${s.name} (${s.code})`, site_id: s.site_id }; }) : [],
                    isc_configuration: props.isc_configuration,
                    track_batch_expiry: props.isc_configuration && props.isc_configuration.track_batch_expiry ? props.isc_configuration.track_batch_expiry : 'N',
                    negative_stock: props.isc_configuration && props.isc_configuration.negative_stock ? props.isc_configuration.negative_stock : 'N',
                    allGstSlabs: formData && formData.gst_slabs ? formData.gst_slabs.map((s) => { return { value: s, label: s + '%' } }) : [],
                    allStatus: formData && formData.status ? formData.status.map((s) => { return { value: s.key, label: s.status } }) : [],
                    isc_prevent_back_day_voucher           :    props.isc_setting && props.isc_setting.isc_prevent_back_day_voucher && props.isc_setting.isc_prevent_back_day_voucher ? props.isc_setting.isc_prevent_back_day_voucher : 'N',
                     isc_item_weighted_average_cost           :    props.isc_setting && props.isc_setting.isc_item_weighted_average_cost && props.isc_setting.isc_item_weighted_average_cost ? props.isc_setting.isc_item_weighted_average_cost : 'N',
                }, () => {
                    this.setState({ buttonDisabled: false });
                  
                    if (props.location && props.location.state && props.location.state.inventoryTransferData) {
                        let inventoryData = props.location.state.inventoryTransferData;
                        let additionalAttributesData = {};
                        if (inventoryData.additional_attribute_data && inventoryData.additional_attribute_data.length > 0) {
                            inventoryData.additional_attribute_data.forEach(attr => {
                                const fieldName = `additional_attributes_${attr.key}`;
                                additionalAttributesData[fieldName] = attr.value || attr.value_display || '';
                            });
                        }

                        let inventoryTransferItemNew =
                            inventoryData.transfer_items.flatMap(demo =>
                                demo.warehouse_indents.map(indent => {
                                    const indentItems = indent.items || [];

                                    const totalQty = indentItems.reduce(
                                        (sum, it) => sum + Number(it.qty || 0),
                                        0
                                    );

                                    const rate = indentItems.length ? Number(indentItems[0].rate || 0) : 0;
                                    const gst = indentItems.length ? Number(indentItems[0].gst || 0) : 0;
                                    const remark = indentItems.length ? (indentItems[0].remark || '') : '';

                                    return {
                                        ...indent,
                                        item_id: demo.item_profile.id,
                                        item_profile: demo.item_profile,
                                        qty: totalQty,
                                        rate,
                                        gst,
                                        remark,
                                        items: indentItems
                                    };
                                })
                            );

                        const inventoryTransferItems = this.buildInventoryTransferItems(
                            inventoryTransferItemNew, {}, true
                        );

                        // Store the shipping_address_id and receiving_address_id to use later
                        const shippingAddressId = inventoryData.shipping_address_id;
                        const receivingAddressId = inventoryData.receiving_address_id;
                        const dispatchingAddressId = inventoryData.dispatching_address_id;

                        this.setState({
                            inventoryDetail: inventoryData,
                            buttonDisabled: true,
                            editInventoryTransfer: true,
                            usePurchaseRate: false,
                            loading_item: true,
                            dispatchingWarehouseDetail: inventoryData.dispatching_address ? inventoryData.dispatching_address : null,
                            receivingWarehouseDetail: inventoryData.receiving_address ? inventoryData.receiving_address : null,
                            shipping_address_id: shippingAddressId || null,
                            receiving_address_id: receivingAddressId || null,
                            dispatching_address_id: dispatchingAddressId || null,
                            addInventoryTransferForm: {
                                transaction_id: inventoryData.transaction_id,
                                transaction_date: inventoryData.transaction_date,
                                warehouse_from: inventoryData.warehouse_from,
                                warehouse_to: inventoryData.warehouse_to,
                                invoice_number: inventoryData.invoice_number ? inventoryData.invoice_number : '',
                                invoice_date: inventoryData.invoice_date ? inventoryData.invoice_date : '',
                                eway_number: inventoryData.eway_number ? inventoryData.eway_number : '',
                                eway_date: inventoryData.eway_date ? inventoryData.eway_date : '',
                                document_number: inventoryData.document_number ? inventoryData.document_number : '',
                                document_date: inventoryData.document_date ? inventoryData.document_date : '',
                                transporter_number: inventoryData.transporter_number ? inventoryData.transporter_number : '',
                                notes: inventoryData.notes ? inventoryData.notes : '',
                                status: inventoryData.status ? inventoryData.status : '',
                                adjustment_amount: inventoryData.adjustment_amount ? inventoryData.adjustment_amount : '',
                                vechicle_registration_no: inventoryData.vechicle_registration_no ? inventoryData.vechicle_registration_no : '',
                                no_of_boxes: inventoryData.no_of_boxes ? inventoryData.no_of_boxes : '',
                                weight: inventoryData.weight ? inventoryData.weight : '',
                                unit_of_weight: inventoryData.unit_of_weight ? inventoryData.unit_of_weight : '',
                                fullfill_purchase_qty: inventoryData.fullfill_purchase_qty ? inventoryData.fullfill_purchase_qty : 'N'
                            },
                            inventoryData: inventoryData,
                            userStatus: inventoryData.userStatus && inventoryData.userStatus.length ? inventoryData.userStatus : [],
                            additionalAttributesData: additionalAttributesData
                        }, () => {
                            let warehouseLoadCount = 0;
                            const totalWarehousesToLoad = 2;

                            const onWarehouseLoaded = () => {
                                warehouseLoadCount++;
                                if (warehouseLoadCount === totalWarehousesToLoad) {
                                    this.getItemDetailsWithIndent(inventoryTransferItems, { fromVoucher: false });
                                    this.filterAllStatusOptions();
                                }
                            };

                            // Load dispatching warehouse with callback
                            this.getDispatchingWarehouseDetail(
                                this.state.addInventoryTransferForm.warehouse_from,
                                (dispatchWarehouseData) => {
                                    
                                    // After dispatching warehouse is loaded, set the selected address
                                    if (dispatchingAddressId && dispatchWarehouseData) {
                                        const addressList = dispatchWarehouseData.address_list || [];
                                        const selectedDispatchAddress = addressList.find(addr => addr.id == dispatchingAddressId);
                                      
                                        if (selectedDispatchAddress) {
                                            this.setState({
                                                selectDispatchAddress: selectedDispatchAddress,
                                                dispatchingWarehouseDetail: selectedDispatchAddress
                                            });
                                        }
                                    }
                                    onWarehouseLoaded();
                                }
                            );

                            // Load receiving warehouse with callback
                            this.getReceivingWarehouseDetail(
                                this.state.addInventoryTransferForm.warehouse_to,
                                (receiveWarehouseData) => {
                                    // After receiving warehouse is loaded, set the selected addresses
                                    if (receiveWarehouseData) {
                                        const addressList = receiveWarehouseData.address_list || [];

                                        // Set receiving address (warehouse address)
                                        let selectedReceivingAddress = null;
                                        if (receivingAddressId) {
                                            selectedReceivingAddress = addressList.find(addr => addr.id == receivingAddressId);
                                        }
                                        // If not found or no ID, use default
                                        if (!selectedReceivingAddress) {
                                            selectedReceivingAddress = addressList.find(addr => addr.is_warehouse_address === "Y") || null;
                                        }

                                        // Set shipping address
                                        let selectedShippingAddressObj = null;
                                        if (shippingAddressId) {
                                            selectedShippingAddressObj = addressList.find(addr => addr.id == shippingAddressId);
                                        }
                                        // If shipping address ID is provided but not found in address_list, it might be a warehouse address
                                        if (shippingAddressId && !selectedShippingAddressObj) {
                                            selectedShippingAddressObj = selectedReceivingAddress;
                                        }

                                        this.setState({
                                            selectReceivingAddress: selectedReceivingAddress,
                                            selectedShippingAddress: selectedShippingAddressObj,
                                            receiving_address_id: receivingAddressId || selectedReceivingAddress?.id,
                                            shipping_address_id: shippingAddressId || selectedShippingAddressObj?.id,
                                        }, () => {
                                            // Load address list for modal
                                            this.getReceivingWarehouseAddressList(
                                                this.state.addInventoryTransferForm.warehouse_to,
                                                1,
                                                shippingAddressId
                                            );
                                        });
                                    }
                                    onWarehouseLoaded();
                                }
                            );
                        });
                    }

                    if (
                        props.location?.state?.addInventoryFromPurchase ||
                        props.location?.state?.addInventoryFromPurchaseReport ||
                        props.location?.state?.addInventoryFromItemDemand
                    ) {
                        const stateData =
                            props.location.state.addInventoryFromPurchase ||
                            props.location.state.addInventoryFromPurchaseReport ||
                            props.location.state.addInventoryFromItemDemand;

                        const rawItems =
                            stateData.items ||
                            stateData?.demandData?.items ||
                            [];

                        const inventoryTransferItems =
                            this.buildInventoryTransferItems(rawItems);

                        const warehouse_from =
                            stateData.warehouse_id || stateData.warehouse_from || null;

                        const warehouse_to =
                            stateData.warehouse_to || null;

                        this.setState(
                            {
                                editInventoryTransfer: false,     // 🔑
                                usePurchaseRate: !!(
                                    props.location?.state?.addInventoryFromPurchase ||
                                    props.location?.state?.addInventoryFromPurchaseReport
                                ),
                                buttonDisabled: true,
                                loading_item: true,
                                fromVoucher:true,
                                addInventoryTransferForm: {
                                    ...this.state.addInventoryTransferForm,
                                    warehouse_from,
                                    warehouse_to
                                }
                            },
                            () => {
                                // ✅ ONLY LOAD AVAILABLE WAREHOUSE
                                this.handleWarehouseLoadAndThen(
                                    warehouse_from,
                                    warehouse_to,
                                    () => {
                                        this.getItemDetailsWithIndent(inventoryTransferItems,{ fromVoucher: true });
                                        this.filterAllStatusOptions();
                                    }
                                );
                            }
                        );
                    }

                    if (props.location?.state?.addInventoryFromIndent) {
                        const inventoryData = props.location.state.addInventoryFromIndent;

                        const inventoryTransferItems = this.buildInventoryTransferItems(
                            inventoryData.items || [],
                            {
                                autoQty: true,          // 🔑 fullfill / pending qty
                                usePurchaseRate: true
                            }
                        );

                        this.setState(
                            {
                                fromVoucher: true,
                                editInventoryTransfer: false,
                                usePurchaseRate: true,
                                buttonDisabled: true,
                                loading_item: true,
                                addInventoryTransferForm: {
                                    ...this.state.addInventoryTransferForm,
                                    warehouse_from: inventoryData.warehouse_from || null,
                                    warehouse_to: inventoryData.warehouse_to || null
                                }
                            },
                            () => {
                                this.handleWarehouseLoadAndThen(
                                    inventoryData.warehouse_from,
                                    inventoryData.warehouse_to,
                                    () => {
                                        this.getItemDetailsWithIndent(
                                            inventoryTransferItems,
                                            { fromVoucher: true }
                                        );
                                        this.filterAllStatusOptions();
                                    }
                                );
                            }
                        );
                    }


    
                    if (props.location && props.location.state && props.location.state.transferPurchaseFromIndent) {
                        let inventoryData = props.location.state.transferPurchaseFromIndent;

                        this.setState({
                            indent_transaction_id: inventoryData.transactionId ? inventoryData.transactionId : '',
                            buttonDisabled: true,
                            addInventoryTransferForm: {
                                ...this.state.addInventoryTransferForm,
                                warehouse_to: inventoryData.warehouse_id,
                                fullfill_purchase_qty: 'Y',
                            },
                        }, () => {
                            this.getReceivingWarehouseDetail(inventoryData.warehouse_id);
                            this.getItemWisePurchaseList(inventoryData.transactionId)
                        })
                        
                        
                    }
                });
            });
        }
    }

  buildInventoryTransferItems = (inputItems = [], options = {},editCase=false) => {
   
    return inputItems.map(item => ({
      
        // item identity
        item_id:
            item.item_id ||
            item.item?.id ||
            item.item_profile?.id ||
            item.id,

        // full item object (used later)
        item: item.item || item.item_profile || item,

        // qty logic (EXACT MATCH)
        qty: options.autoQty
            ? (item.fullfill_qty || item.pending_qty || item.qty || 0)
            : (item.qty || 0),

            

        // rate logic (EXACT MATCH)
        rate: this.state.isc_item_weighted_average_cost == 'Y' && editCase == false  ? item?.item?.weighted_average_cost : options.usePurchaseRate
            ? (item.rate || item?.item?.purchase_price || 0)
            : (item.rate || item?.item?.consumption_price || 0),
        gst : item.gst ? Number(item.gst) : 0,

        remark: item.remark || "",

        // batch selection (edit only)
        items: item.items || [],

        // indent mapping
        indent_transaction_id: item.indent_transaction_id || item.indent_id || "",
        indent_qty: item.indent_qty || 0,
        pending_qty: item.pending_qty || 0,

        // UI helpers
        measuring_unit:
            item.item?.unit_name ||
            item.item_profile?.unit_name ||
            "",

        // flags (important for existing logic)
        stock_loading: true,
        allApiCallsCompleted: false,
        weighted_average_cost : item?.item?.weighted_average_cost || 0
    }));
};


    handleWarehouseLoadAndThen = (
        warehouseFrom,
        warehouseTo,
        afterLoad
    ) => {
        let loadCount = 0;

        const totalToLoad =
            (warehouseFrom ? 1 : 0) +
            (warehouseTo ? 1 : 0);

        // 🔒 If nothing to load, continue immediately
        if (totalToLoad === 0) {
            afterLoad && afterLoad();
            return;
        }

        const onWarehouseLoaded = () => {
            loadCount++;
            if (loadCount === totalToLoad) {
                afterLoad && afterLoad();
            }
        };

        if (warehouseFrom) {
            this.getDispatchingWarehouseDetail(
                warehouseFrom,
                onWarehouseLoaded
            );
        }

        if (warehouseTo) {
            this.getReceivingWarehouseDetail(
                warehouseTo,
                onWarehouseLoaded
            );
        }
    };

   
    addRemark       =   (data,k)      =>      {
        let allRows                 =   this.state.inventoryTransferItemRows;
        let itemdata = {...data,isAddRemark : true}
        allRows[k]                  =   {...this.state.inventoryTransferItemRows[k] , item  : itemdata};
        this.setState({inventoryTransferItemRows : allRows});
    }

    getItemWisePurchaseList             =       (indent_transaction_id)     =>      {
        if (indent_transaction_id) {
          
            HttpAPICall.withAthorization('GET', this.purchaseReportUrl, this.props.access_token, {indent_transaction_id: indent_transaction_id}, {}, (resp) => {
                let respData = resp.data;
                let filteredDispatchingWarehouses      =   [];
                if(this.state.allDispatchingWarehouses && this.state.allDispatchingWarehouses.length > 0 && respData && respData.data && respData.data.length > 0){
                    filteredDispatchingWarehouses = this.state.allDispatchingWarehouses.filter(warehouse =>
                        respData.data.some(item => item.warehouse_id === warehouse.value)
                    );
                  
                }else{
                    filteredDispatchingWarehouses    =   []
                }

                if(filteredDispatchingWarehouses &&  filteredDispatchingWarehouses.length > 0){
                    this.setState({
                        buttonDisabled:false,
                        allDispatchingWarehouses : filteredDispatchingWarehouses.filter(
                         warehouse => warehouse.value !== Number(this.state.addInventoryTransferForm.warehouse_to)
                   )},() => {
                      this.handleButtonEnable()
                        
                   })
                }else{
                    this.setState({allDispatchingWarehouses : [],buttonDisabled:false})
                }
              
            })
        } 
    }

    inwardHistoryModalHandle = (item) => {
        if (this.inwardHistoryRef.current && item && this.state.dispatchingWarehouseDetail) {
            this.inwardHistoryRef.current.initModalHandler(item, this.state.dispatchingWarehouseDetail);
        }
    }

    getItemDetailsWithIndent = (
        inventoryTransferItems = [],
        options = {}
    ) => {
        const { fromVoucher = false } = options;
        if (!inventoryTransferItems.length) return;

        this.setState({ loading_item: true, buttonDisabled: true });

        const itemIds = inventoryTransferItems.map(it => it.item_id);

        HttpAPICall.withAthorization(
            "GET",
            this.itemsUrl,
            this.props.access_token,
            {
                item_ids: itemIds,
                need_indent: "Y",
                current_stock: "Y",
                need_weighted_average_cost: this.state.isc_item_weighted_average_cost,
                warehouse_id: this.state.addInventoryTransferForm.warehouse_from,
                indent_warehouse_id: this.state.addInventoryTransferForm.warehouse_to,
                indent_transaction_ids: inventoryTransferItems.filter(i => i.indent_transaction_id !== "").map(i => i.indent_transaction_id),

            },
            null,
            (resp) => {
                const apiItems = resp?.data?.data || [];

                const rows = inventoryTransferItems.map(editRow => {

                    const apiItem = apiItems.find(
                        i => String(i.id) === String(editRow.item_id)
                    );
                    if (!apiItem) return null;

                    /* ================= INDENT LIST ================= */
                    const all_available_indent =
                        apiItem.indent_item_list?.map(ind => ({
                            value: ind.transaction_id,
                            label: ind.transaction_id,
                            selectedIndentId: ind
                        })) || [];

                    /* ================= SELECTED INDENT ================= */
                    const selectedIndent =
                        apiItem.indent_item_list?.find(
                            i => String(i.transaction_id) ===
                                String(editRow.indent_transaction_id)
                        ) || null;

                    /* ================= RATE ================= */
                    let rate = 0;
                    if (this.state.isc_item_weighted_average_cost == 'Y') {
                        if (this.state.inventoryData) {
                            // EDIT CASE: compute simple average of selected batch weighted_average_costs when available
                            const selectedBatches = editRow.items || [];
                            let rates = [];
                            if (selectedBatches.length > 0) {
                                selectedBatches.forEach(b => {
                                    const v = parseFloat(b.weighted_average_cost ?? NaN);
                                    if (!isNaN(v)) rates.push(v);
                                });
                            }

                            // Fallback to current_stocks if selected batches don't have WAC
                            if (rates.length === 0 && apiItem.current_stock && apiItem.current_stock.length) {
                                apiItem.current_stock.forEach(cs => {
                                    const v = parseFloat(cs.weighted_average_cost ?? NaN);
                                    if (!isNaN(v)) rates.push(v);
                                });
                            }

                            if (rates.length > 0) {
                                const sum = rates.reduce((s, r) => s + r, 0);
                                rate = Number(Number(sum / rates.length).toFixed(2));
                            } else {
                                rate = editRow.rate ? editRow.rate : apiItem.consumption_price ? apiItem.consumption_price : 0;
                            }
                        } else {
                            // NEW ITEM (after search): use simple average across current_stock WACs
                            const stocks = apiItem.current_stock || [];
                            if (stocks.length > 0) {
                                const sum = stocks.reduce((s, st) => {
                                    const v = parseFloat(st.weighted_average_cost ?? NaN);
                                    return s + (isNaN(v) ? 0 : v);
                                }, 0);
                                rate = Number(Number(sum / stocks.length).toFixed(2));
                            } else {
                                rate = apiItem.weighted_average_cost ?? (editRow.rate ? editRow.rate : apiItem.consumption_price ? apiItem.consumption_price : 0);
                            }
                        }
                    } else {
                        rate = editRow.rate ? editRow.rate : apiItem.consumption_price ? apiItem.consumption_price : 0;
                    }

                    if (this.state.usePurchaseRate === true && this.state.isc_item_weighted_average_cost == 'N') {
                        rate = apiItem.purchase_price || rate;
                    }

                    /* ================= QTY (LOCKED FOR VOUCHER) ================= */
                    const resolvedQty = fromVoucher === true
                        ? Number(editRow.qty || editRow.pending_qty || 0)
                        : (
                            Number(editRow.qty) > 0
                                ? Number(editRow.qty)
                                : Number(editRow.pending_qty || 0)
                        );

                    /* ================= STOCK (NO INVENTORY API) ================= */
                    const selectedBatches = editRow.items || [];
                    const addBackMap = {};

                    if (this.state.editInventoryTransfer === true) {
                        selectedBatches.forEach(b => {
                            const key = `${b.batch_number || ""}_${b.expiry_date || ""}`;
                            addBackMap[key] =
                                (addBackMap[key] || 0) + Number(b.qty || 0);
                        });
                    }

                    let current_stocks = [];
                    let qty_without_batch = 0;
                    let freeqty_without_batch = 0;
                    const selectedBatchQty =
                        (editRow.items || []).reduce(
                            (s, b) => s + Number(b.qty || 0),
                            0
                        );

                    const pendingQty =
                        this.state.editInventoryTransfer === true
                            ? Number(selectedIndent?.pending_qty || 0) + selectedBatchQty
                            : Number(selectedIndent?.pending_qty || 0);

                    if (apiItem.current_stock?.length) {
                        current_stocks = apiItem.current_stock.map(st => {
                            const key = `${st.batch_number || ""}_${st.expiry_date || ""}`;
                            const addBackQty = addBackMap[key] || 0;

                            const qty = Number(st.qty);
                            const free_qty = Number(st.free_qty) + addBackQty;

                            return {
                                stock: {
                                    ...st,
                                    id: st.stock_id || st.id,
                                    expiry_date_display: st.expiry_date,
                                    qty,
                                    free_qty
                                },
                                batch_number: st.batch_number,
                                expiry_date: st.expiry_date,
                                qty,
                                free_qty
                            };
                        });

                        qty_without_batch = current_stocks.reduce((s, a) => s + a.qty, 0);
                        freeqty_without_batch = current_stocks.reduce((s, a) => s + a.free_qty, 0);
                    }

                    return {
                        ...this.iniitTransferItemRow,

                        item: apiItem,

                        qty: resolvedQty,
                        rate,
                        remark: editRow.remark || "",
                        gst: editRow.gst ? editRow.gst : 0,

                        // 🔑 INDENT DATA (MATCHES OLD LOGIC)
                        all_available_indent,
                        indent_id: selectedIndent?.transaction_id || "",
                        indent_qty: selectedIndent?.indent_qty || 0,
                        pending_qty: pendingQty,
                        transaction_date:
                            selectedIndent?.transaction_date_display || "",

                        selected_batch_list: (editRow.items || []).map(b => {
                            if (this.state.isc_item_weighted_average_cost == 'Y') {
                                // try to find matching stock in current_stocks to pick batch-level WAC
                                const matchStock = current_stocks.find(cs => {
                                    const batchMatch = (cs.batch_number === b.batch_number) || (cs.batch_number == null && b.batch_number == null) || (cs.batch_number == undefined && b.batch_number == undefined);
                                    const expiryMatch = (cs.expiry_date === b.expiry_date) || (cs.expiry_date == null && b.expiry_date == null) || (cs.expiry_date == undefined && b.expiry_date == undefined);
                                    return batchMatch && expiryMatch;
                                });

                                return {
                                    batch_number: b.batch_number ?? null,
                                    expiry_date: b.expiry_date ?? null,
                                    qty: Number(b.qty || 0),
                                    expiry_date_display: b.expiry_date_display || (matchStock?.stock?.expiry_date_display || null),
                                    stock_id: b.stock_id || matchStock?.stock?.stock_id || matchStock?.stock?.id || null,
                                    weighted_average_cost: matchStock?.stock?.weighted_average_cost ?? (b.weighted_average_cost ?? apiItem.weighted_average_cost ?? null)
                                };
                            }

                            return {
                                batch_number: b.batch_number ?? null,
                                expiry_date: b.expiry_date ?? null,
                                qty: Number(b.qty || 0),
                                expiry_date_display: b.expiry_date_display || null,
                                stock_id: b.stock_id || null
                            };
                        }),
                        selected_stock: null,

                        measuring_unit:
                            editRow.measuring_unit || apiItem.unit_name,

                        current_stocks,
                        qty_without_batch,
                        freeqty_without_batch,

                        stock_loading: false,
                        allApiCallsCompleted: true,
                        weighted_average_cost: (apiItem.current_stock && apiItem.current_stock[0] && apiItem.current_stock[0].weighted_average_cost) ?? apiItem.weighted_average_cost
                    };
                }).filter(Boolean);

                this.setState(
                    {
                        inventoryTransferItemRows: rows,
                        loading_item: false
                    },
                    () => {
                        // 🔒 DO NOT RECALCULATE QTY FOR VOUCHER
                        if (!fromVoucher) {
                            rows.forEach((_, i) =>
                                this.calculateAndUpdateItemQty(i)
                            );
                        }
                        this.handleButtonEnable();
                    }
                );
            }
        );
    };


    calculateAndUpdateItemQty = (rowIndex, fromVoucher = true) => {
        const rows = [...this.state.inventoryTransferItemRows];
        const row = rows[rowIndex];
        if (this.state.fromVoucher === true && fromVoucher == true) {
            this.setState({ inventoryTransferItemRows: rows });
            return;
        }
        if (!row || !row.current_stocks?.length) return;

        let totalQty = 0;

        /* EDIT MODE → TRUST SELECTED BATCHES */
        if (row.selected_batch_list?.length) {
            totalQty = row.selected_batch_list.reduce(
                (s, b) => s + Number(b.qty || 0),
                0
            );
        } else if (row.current_stocks.length === 1) {
            totalQty = Number(row.current_stocks[0].free_qty || 0);
        }

        if (row.indent_id && row.pending_qty) {
            totalQty = Math.min(totalQty, Number(row.pending_qty));
        }

        /* 🔥 ENSURE ITEM JSX FREE QTY MATCHES MODAL */
        row.qty = totalQty;
        row.stock_qty = totalQty;
        row.freeqty_without_batch = totalQty;
        row.amount = Number(row.rate || 0) * totalQty;

        rows[rowIndex] = row;
        this.setState({ inventoryTransferItemRows: rows });
    };


    filterAllStatusOptions                  =   ()  =>  {
        let allStatus                    =   this.state.allStatus;
        if(this.state.userStatus.length > 0) {
            allStatus                    =   allStatus.filter(allStatus =>  this.state.userStatus.find(ns => ns.key == allStatus.value) ? true : false );
            this.setState({
                allStatus        :   allStatus
            });
        }
    }
    onDispatchingWarehouseChange = (selectedOption) => {
        const warehouseId = selectedOption ? selectedOption.value : null;
   
        this.setState({
            dispatchingWarehouseDetail: null,
        }, () => {
            this.getDispatchingWarehouseDetail(warehouseId);
             this.updateIndentAndStockInfo(warehouseId);
        });
    }

    updateIndentAndStockInfo = () => {
    const rowsWithItems = this.state.inventoryTransferItemRows.filter(row => row?.item?.id);
    
    if (rowsWithItems.length === 0) {
        return;
    }

    this.setState({ loading_item: true, buttonDisabled: true });

    HttpAPICall.withAthorization(
        'GET',
        this.itemsUrl,
        this.props.access_token,
        {
            item_ids: rowsWithItems.map(row => row.item.id),
            warehouse_id: this.state.addInventoryTransferForm.warehouse_from,
            current_stock: 'Y',
            need_indent: 'Y',
            need_weighted_average_cost : this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N',
            indent_transaction_ids: rowsWithItems.filter(i => i.indent_transaction_id !== "").map(i => i.indent_transaction_id),
            indent_warehouse_id: this.state.addInventoryTransferForm.warehouse_to
        },
        {},
        (resp) => {
            const apiItems = resp.data.data || [];
            let rows = [...this.state.inventoryTransferItemRows];

            rowsWithItems.forEach((itemRow, rowIndex) => {
                const apiItem = apiItems.find(i => String(i.id) === String(itemRow.item.id));
                if (!apiItem) return;

                // Update indent information
                const indentList = apiItem.indent_item_list || [];
                
                // Keep current indent selection if it exists in new list
                const currentIndentId = itemRow.indent_id;
                let selectedIndent = null;
                
                if (currentIndentId) {
                    selectedIndent = indentList.find(ind => 
                        String(ind.transaction_id) === String(currentIndentId)
                    );
                }

                const all_available_indent = indentList.map(ind => ({
                    value: String(ind.transaction_id),
                    label: String(ind.transaction_id),
                    selectedIndentId: ind
                }));

                // Update pending qty based on selected indent
                let pendingQty = 0;
                if (selectedIndent) {
                    if (this.state.addInventoryTransferForm.fullfill_purchase_qty === 'Y') {
                        pendingQty = selectedIndent.purchase_qty || 0;
                    } else {
                        pendingQty = selectedIndent.pending_qty || 0;
                    }
                }

                // Update current stocks info
                let current_stocks = [];
                let qty_without_batch = 0;
                let freeqty_without_batch = 0;
                
                if (apiItem.current_stock) {
                    current_stocks = apiItem.current_stock.map(st => ({
                        stock: {
                            ...st,
                            id: st.stock_id || st.id,
                            expiry_date_display: st.expiry_date
                        },
                        batch_number: st.batch_number,
                        expiry_date: st.expiry_date,
                        qty: Number(st.qty),
                        free_qty: Number(st.free_qty)
                    }));

                    qty_without_batch = current_stocks.reduce((sum, cs) => sum + cs.qty, 0);
                    freeqty_without_batch = current_stocks.reduce((sum, cs) => sum + cs.free_qty, 0);
                }

                // Reset batch selections when warehouse changes
                rows[rowIndex] = {
                    ...itemRow,
                    all_available_indent: all_available_indent,
                    indent_qty: selectedIndent?.indent_qty || itemRow.indent_qty || 0,
                    pending_qty: pendingQty || itemRow.pending_qty || 0,
                    current_stocks: current_stocks,
                    qty_without_batch: qty_without_batch,
                    freeqty_without_batch: freeqty_without_batch,
                    // RESET batch selections:
                    selected_batch_list: [],
                    selected_stock: null,
                    stock_loading: false,
                    allApiCallsCompleted: true
                };
            });

            this.setState({ 
                inventoryTransferItemRows: rows, 
                loading_item: false,
                buttonDisabled: false 
            }, () => {
                // After updating stock info, auto-calculate quantities
                rowsWithItems.forEach((_, index) => {
                    this.calculateAndUpdateItemQty(index);
                });
            });
        }
    );
}
    
  
    
    onReceivingWarehouseChange = (selectedOption) => {
        this.setState({
            receivingWarehouseDetail: null,
            sameReceivingWarehouseAddress: null,
            selectReceivingAddress: null,
            selectedShippingAddress: null,
            receiving_address_id: null,     // Reset when warehouse changes
            shipping_address_id: null,      // Reset when warehouse changes
            receivingWarehouseDetailLoading: true,
        });

        if (selectedOption?.value) {
            this.getReceivingWarehouseDetail(selectedOption.value);
        }
    }
/********************GET WAREHOUSE DETAILS API ******************************* */
    getDispatchingWarehouseDetail = (selectedOption, callback = null) => {
    if (selectedOption) {
        let id = selectedOption.value ? selectedOption.value : selectedOption;
        this.setState({ dispatchingWarehouseDetail: null, dispatchingWarehouseDetailLoading: true });

        HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + id, this.props.access_token, {need_address_list : 'Y'}, {}, (resp) => {
            let respData = resp.data;
            if (this.state.selectDispatchAddress && this.state.selectReceivingAddress) {
                if (this.state.selectDispatchAddress?.state_id === this.state.selectReceivingAddress?.state_id) {
                    this.setState({ gstTypeName: 'GST' });
                } else {
                    this.setState({ gstTypeName: 'IGST' });
                }
            } else {
                if (this.state.receivingWarehouseDetail?.state_id === respData.data.state_id) {
                    this.setState({ gstTypeName: 'GST' });
                } else {
                    this.setState({ gstTypeName: 'IGST' });
                }
            }
            this.setState({
                dispatchingWarehouseDetail: this.state.selectDispatchAddress ? this.state.selectDispatchAddress : respData.data,
                sameDispatchWarehouseAddress: respData.data,
                indent_listing: [],
                totalIndentListingCount: 0,
                indnetListingMeta: null,
                listingLoaded: false
            });
        }).then(() => {
            this.setState({ dispatchingWarehouseDetailLoading: false });
            if (callback) callback(this.state.dispatchingWarehouseDetail); // Execute callback
        });
    } else {
        this.setState({ dispatchingWarehouseDetail: null });
        if (callback) callback(); // Execute callback
    }
}

    getReceivingWarehouseDetail = (selectedOption, callback = null) => {
        if (selectedOption) {
            let id = selectedOption.value ? selectedOption.value : selectedOption;
            this.setState({
                receivingWarehouseDetail: null,
                receivingWarehouseDetailLoading: true,
                receiving_address_id: null,
                shipping_address_id: null,
                selectReceivingAddress: null,
                selectedShippingAddress: null
            });

            let params = { shipping_address: 'Y' };

            // For edit case, need address list
            if (this.state.inventoryData || this.state.editInventoryTransfer) {
                params.need_address_list = 'Y';
            }

            HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + id, this.props.access_token, params, {}, (resp) => {
                let respData = resp.data;
                const addressList = respData.data.address_list || [];
                let defaultAddress = addressList.find(addr => addr.is_warehouse_address === "Y") || null;

                const warehouseData = {
                    ...respData.data,
                    address_list: addressList
                };

                const defaultId = defaultAddress?.id || warehouseData?.id;
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
                const receiveState = defaultAddress?.state_id || warehouseData?.state_id;

                // For ADD case: Use shipping_address from response if available
                let selectedShippingAddr = defaultAddress;
                let shippingAddrId = defaultId;

                if (!this.state.editInventoryTransfer && respData.data.shipping_address) {
                    selectedShippingAddr = respData.data.shipping_address;
                    shippingAddrId = respData.data.shipping_address.id;
                }

                // For EDIT case: Use saved shipping_address_id from props
                if (this.state.editInventoryTransfer && this.state.shipping_address_id) {
                    const savedAddress = addressList.find(addr => addr.id == this.state.shipping_address_id);
                    if (savedAddress) {
                        selectedShippingAddr = savedAddress;
                        shippingAddrId = savedAddress.id;
                    }
                }

                this.setState({
                    receivingWarehouseDetail: warehouseData,
                    sameReceivingWarehouseAddress: warehouseData,
                    receivingWarehouseAddressList: addressList,
                    selectReceivingAddress: defaultAddress,
                    selectedShippingAddress: selectedShippingAddr,
                    receiving_address_id: defaultId,
                    shipping_address_id: shippingAddrId,
                    gstTypeName: dispatchState === receiveState ? "GST" : "IGST",
                    receivingWarehouseDetailLoading: false,
                }, () => {
                    if (callback) callback(warehouseData);

                    // Refresh indent for all items when warehouse loads
                    if (!this.state.editInventoryTransfer || !this.state.loading_item) {
                        this.refreshIndentForAllItems();
                    }
                });
            }).catch(() => {
                this.setState({ receivingWarehouseDetailLoading: false });
                if (callback) callback(null);
            });
        } else {
            this.setState({
                receivingWarehouseDetail: null,
                sameReceivingWarehouseAddress: null,
                selectReceivingAddress: null,
                selectedShippingAddress: null,
                receiving_address_id: null,
                shipping_address_id: null
            });
            if (callback) callback(null);
        }
    }
    // getReceivingWarehouseDetail = (selectedOption, callback = null) => {
    //     if (selectedOption) {
    //         let id = selectedOption.value ? selectedOption.value : selectedOption;
    //         this.setState({
    //             receivingWarehouseDetail: null,
    //             receivingWarehouseDetailLoading: true,
    //             receiving_address_id: null,
    //             shipping_address_id: null,
    //             selectReceivingAddress: null,
    //             selectedShippingAddress: null
    //         });

    //         // Build params conditionally - DON'T pass need_address_list for add case
    //         let params = { shipping_address: 'Y' };

    //         // Only pass need_address_list for non-add cases (edit, view, etc.)
    //         if (this.state.inventoryData) {
    //             params.need_address_list = 'Y';
    //         }

    //         HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + id, this.props.access_token, params, {}, (resp) => {
    //             let respData = resp.data;

    //             const addressList = respData.data.address_list || [];

    //             let defaultAddress = addressList.find(addr =>
    //                 addr.is_warehouse_address === "Y"
    //             ) || null;

    //             const warehouseData = {
    //                 ...respData.data,
    //                 address_list: addressList
    //             };

    //             const defaultId = defaultAddress?.id || warehouseData?.id;

    //             const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
    //             const receiveState = defaultAddress?.state_id || warehouseData?.state_id;

    //             // Handle shipping_address for add case only
    //             let selectedShippingAddr = defaultAddress;
    //             let shippingAddrId = defaultId;

    //             // Only use shipping_address from response for ADD case (not edit)
    //             if (!this.state.editInventoryTransfer && respData.data.shipping_address) {
    //                 selectedShippingAddr = respData.data.shipping_address;
    //                 shippingAddrId = respData.data.shipping_address.id;
    //             }

    //             this.setState({
    //                 receivingWarehouseDetail: warehouseData,
    //                 sameReceivingWarehouseAddress: warehouseData,
    //                 receivingWarehouseAddressList: addressList,
    //                 selectReceivingAddress: defaultAddress,
    //                 selectedShippingAddress: selectedShippingAddr,
    //                 receiving_address_id: defaultId,
    //                 shipping_address_id: shippingAddrId,
    //                 gstTypeName: dispatchState === receiveState ? "GST" : "IGST",
    //                 receivingWarehouseDetailLoading: false,
    //             }, () => {
    //                 if (callback) callback(warehouseData);

    //                 if (!this.state.editInventoryTransfer || !this.state.loading_item) {
    //                     this.refreshIndentForAllItems();
    //                 }
    //             });
    //         }).then(() => {
    //             this.setState({ receivingWarehouseDetailLoading: false });
    //         });
    //     } else {
    //         this.setState({
    //             receivingWarehouseDetail: null,
    //             sameReceivingWarehouseAddress: null,
    //             selectReceivingAddress: null,
    //             selectedShippingAddress: null,
    //             receiving_address_id: null,
    //             shipping_address_id: null
    //         });
    //         if (callback) callback(null);
    //     }
    // }

   
    addNewItemRow                           =   ()  =>  {
        this.setState({inventoryTransferItemRows : [...this.state.inventoryTransferItemRows, {item : null}] });
    }

    removeItemRow                           =   (k) =>  {
        let allRows                 =   this.state.inventoryTransferItemRows;
        if(allRows.length > 1) {
            allRows.splice(k, 1);
            this.setState({inventoryTransferItemRows : allRows});
        }
    }

    itemViewModalInit                       =   (item,k)  =>  {
        if(item){
            if(this.itemDetailsRef.current && typeof this.itemDetailsRef.current.modalInit === 'function') {
                this.itemDetailsRef.current.modalInit(item);
                this.setState({itemRowNumber : k})
            } else {
                console.error('ItemDetailsModal ref not properly initialized or modalInit function does not exist', {
                    refExists: !!this.itemDetailsRef.current,
                    haModalInit: this.itemDetailsRef.current ? typeof this.itemDetailsRef.current.modalInit : 'N/A'
                });
            }
        }

    }

    itemSearchModalInit             =       ()          =>      {
        this.setState(prevState => ({ showItemSearchModal: !prevState.showItemSearchModal }), () => {
            if (this.state.showItemSearchModal) {
                let allRows                 =   this.state.inventoryTransferItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if (this.itemSearchRef.current) {
                    this.itemSearchRef.current.searchItemModalInit(item_ids);
                }
            }
        });
        
    }

    editItemModalInit          =       (data,k)           =>      {
        this.setState(prevState => ({ showItemEditModal: !prevState.showItemEditModal,itemSearchedDetails:data,itemRowNumber:k }), () => {
            if (this.state.showItemEditModal) {
                let allRows                 =   this.state.inventoryTransferItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if(this.editItemModalRef.current){
                    this.editItemModalRef.current.itemEditModalInit(data); 
                }
                
            }
        });
        
    }

    addItemModalInit          =       ()           =>      {
        this.setState(prevState => ({ showItemAddModal: !prevState.showItemAddModal }), () => {
            if (this.state.showItemAddModal) {
                let allRows                 =   this.state.inventoryTransferItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }

                if(this.addItemModalRef.current){
                    this.addItemModalRef.current.itemAddModalInit(); 
                }
            
            }
        });
        
    }

    //****************************CLOSE INVENTORY *********************/
    closeEvent              =           ()      =>      {

        this.props.history.push({pathname: `/inventory_transfer_list`})   
    }
    

    submitEditItem          =       ()      =>      {
        HttpAPICall.withAthorization('GET', this.itemUrl + '/' + this.state.itemSearchedDetails.id, this.props.access_token, null, null, (response) => {
           let selectedItem = {
                label               :   (<Ax>
                                            <b>Item : </b> {response.data.data.name} <small> ({response.data.data.item_code})</small><br/>
                                            <small>
                                                <b>Manufacturer : </b> {response.data.data.manufacturer ? response.data.data.manufacturer.name : ''}<br/>
                                                <b>MPN : </b> {response.data.data.manufacturer_part_no}</small></Ax>),
                value               :   response.data.data.id ,
                display_label       :   `${response.data.data.name} (${response.data.data.item_code})`,
                itemdata            :   response.data.data
            };
            this.setState({
                  itemSearchedDetails        :    {...this.state.itemSearchedDetails,...response.data.data}
               },() => {
                   this.onItemSelect(selectedItem,this.state.itemRowNumber,this.state.inventoryTransferItemRows[this.state.itemRowNumber].qty)
               });
        })
       
    }


    selectItemBatchModalInit = (data, current_stocks, indent_qty = 0, itemRow = 0, batchlist = []) => {
    this.selectItemBatchModal.show();
    
    const rowData = this.state.inventoryTransferItemRows[itemRow];
    const hasIndent = rowData?.indent_id;
    const maxQty = hasIndent ? (rowData.pending_qty || 0) : Infinity;
    
    // Get selected batches - check both batchlist param and rowData
    let selectedBatchList = batchlist || [];
    if (selectedBatchList.length === 0 && rowData?.selected_batch_list) {
        selectedBatchList = rowData.selected_batch_list;
    }
    
  
    
    let current_stock_list = current_stocks.map(test => {
        // Find if this batch is already selected
        const selectedBatch = selectedBatchList.find(batch => {
            // Handle null/undefined batch matching - both must match
            const batchMatch = (batch.batch_number === test.stock.batch_number) || 
                              (batch.batch_number === null && test.stock.batch_number === null) ||
                              (batch.batch_number === undefined && test.stock.batch_number === undefined);
            
            const expiryMatch = (batch.expiry_date === test.stock.expiry_date) ||
                               (batch.expiry_date === null && test.stock.expiry_date === null) ||
                               (batch.expiry_date === undefined && test.stock.expiry_date === undefined);
            
            // Both batch number AND expiry date must match exactly
            return batchMatch && expiryMatch;
        });

         
        if (selectedBatch) {
            // Batch is already selected - use its qty
            return { 
                ...test, 
                new_qty: selectedBatch.qty || 0, 
                stock_qty: selectedBatch.qty || 0,
                isChecked: true  // Mark as checked
            };
        } else {
            // Batch not selected - calculate default qty
            const availableQty = test.stock.free_qty;
            const allocatedQty = hasIndent 
                ? Math.min(availableQty, maxQty)
                : availableQty;
            return { 
                ...test, 
                new_qty: allocatedQty, 
                stock_qty: allocatedQty,
                isChecked: false  // Not checked by default
            };
        }
    });
    

    this.setState({
        selectedItemData: data,
        selectedItemRow: itemRow,
        selectedItemStocks: current_stock_list
    }, () => {
        // Reset form and set checkboxes after state update
        setTimeout(() => {
            if (document.getElementById("selectItemBatchForm")) {
                let form = document.getElementById("selectItemBatchForm");
                form.reset();
                
                // Now check the checkboxes for selected batches
                current_stock_list.forEach((stock) => {
                    if (stock.isChecked) {
                        // Handle null values in selector
                        const batchNum = stock.stock.batch_number || '';
                        const expiryDate = stock.stock.expiry_date || '';
                        const checkbox = document.querySelector(`.batch_expiry_checkbox[value="${batchNum}"][data-expiry_date="${expiryDate}"]`);
                        if (checkbox) {
                            checkbox.checked = true;
                        }
                    }
                });
                
                // Also update the "Select All" checkbox if all are checked
                this.updateSelectAllCheckbox();
            }
        }, 100);
    });
}

    updateSelectAllCheckbox = () => {
        const allCheckboxes = document.getElementsByClassName('batch_expiry_checkbox');
        const allChecked = allCheckboxes.length > 0 &&
            Array.from(allCheckboxes).every(checkbox => checkbox.checked);

        const selectAllCheckbox = document.getElementById('all_batch_list_check');
        if (selectAllCheckbox) {
            selectAllCheckbox.checked = allChecked;
        }
    }

     convertCurrencyWithAPI = async (amount, fromCurrency, toCurrency) => {
            if (!amount || amount === 0) return amount;
            if (fromCurrency === toCurrency) return amount;
    
            try {
                const converter = new CurrencyService(this.props.access_token);
                return await converter.convert(amount, fromCurrency, toCurrency);
            } catch (error) {
                console.error('Currency conversion failed:', error);
                return amount; // Fallback to original amount
            }
        }
   
    onItemSelect = async (itemData, rowIndex, qty = null, rate = null, clearBatch = true) => {
        if (!itemData) return;

        const item = itemData.itemdata || itemData.item || itemData;
        if (!item) return;

        const finalQty = qty ?? 1;
        const fromCurrency = item?.consumption_currency || this.state.defaultCurrency || "INR";
        const toCurrency = this.state.defaultCurrency || "INR";

        let finalRate = 0;
        if (this.state.isc_item_weighted_average_cost == 'Y') {
            // Rule: sum of all current_stock weighted_average_cost / current_stock length
            const stocks = item.current_stock || [];
            if (stocks.length > 0) {
                const sum = stocks.reduce((s, st) => {
                    const v = parseFloat(st.weighted_average_cost ?? NaN);
                    return s + (isNaN(v) ? 0 : v);
                }, 0);
                let avg = sum / stocks.length;

                if (avg > 0 && fromCurrency !== toCurrency) {
                    try {
                        avg = await this.convertCurrencyWithAPI(avg, fromCurrency, toCurrency);
                    } catch (err) {
                        console.error('Currency conversion failed for weighted average rate', err);
                    }
                }

                finalRate = Number(Number(avg).toFixed(2));
            } else {
                let fallbackRate = Number(item?.weighted_average_cost || 0);
                if (fallbackRate > 0 && fromCurrency !== toCurrency) {
                    try {
                        fallbackRate = await this.convertCurrencyWithAPI(fallbackRate, fromCurrency, toCurrency);
                    } catch (err) {
                        console.error('Currency conversion failed for fallback weighted average rate', err);
                    }
                }
                finalRate = Number(Number(fallbackRate).toFixed(2));
            }
        } else {
            // Rule: when ISC weighted average is N, always show consumption price
            let consumptionRate = Number(item?.consumption_price || 0);
            if (consumptionRate > 0 && fromCurrency !== toCurrency) {
                try {
                    consumptionRate = await this.convertCurrencyWithAPI(consumptionRate, fromCurrency, toCurrency);
                } catch (err) {
                    console.error('Currency conversion failed for consumption rate', err);
                }
            }
            finalRate = Number(Number(consumptionRate).toFixed(2));
        }
        
        // Prevent blank rate input if API returns non-numeric values
        finalRate = Number.isFinite(Number(finalRate)) ? Number(finalRate) : 0;

        // Check if item already exists in rows (only for goods category)
        if (item.category === "goods") {
            const existingItem = this.state.inventoryTransferItemRows.find(
                row => row.item && row.item.id === item.id
            );

            if (existingItem) {
                toast.error(
                    "This Item is already available in this Inventory Transfer, please update the item",
                    { position: toast.POSITION.TOP_RIGHT }
                );
                return;
            }
        }

        // Set fields for only this row (1 setState)
        this.setState(prev => {
            const rows = [...prev.inventoryTransferItemRows];
            const row = { ...(rows[rowIndex] || {}) };

            row.item = item;
            row.qty = finalQty;
            row.rate = Number.isFinite(Number(finalRate)) ? Number(finalRate) : 0;
            row.amount = finalQty * (Number.isFinite(Number(finalRate)) ? Number(finalRate) : 0);
            row.itemdata = item;
            row.measuring_unit = item.unit_name;
            row.remark = itemData.remark ? itemData.remark : '';

            // ADDED THE MISSING INDENT LIST VARIABLE
            row.all_available_indent = item.indent_item_list && item.indent_item_list.length > 0
                ? item.indent_item_list.map(list => ({
                    value: list.transaction_id,
                    label: list.transaction_id,
                    selectedIndentId: list,
                }))
                : [];

            row.stock_loading = true;
            row.allApiCallsCompleted = false;

            if (clearBatch) {
                row.selected_stock = null;
                row.current_stocks = [];
            }

            rows[rowIndex] = row;

            return { inventoryTransferItemRows: rows };
        }, () => {
            // Load stock only for this row
            if (item.id && item.category === "goods") {
                this.getItemInventoryLevel(item.id, rowIndex);
            } else {
                // Non-goods → immediately mark complete
                this.setState(prev => {
                    const rows = [...prev.inventoryTransferItemRows];
                    if (rows[rowIndex]) {
                        rows[rowIndex].stock_loading = false;
                        rows[rowIndex].allApiCallsCompleted = true;
                    }
                    return { inventoryTransferItemRows: rows };
                }, this.handleButtonEnable);
            }

            // Add empty row ONLY for single-item usage
            this.addNewItemRow();
        });
    };

   

   getItemInventoryLevel = (item_id, rowIndex, preSelected = null, batch_number = null, expiry_date = null) => {
    if (!item_id) return;

    // Mark only this row as loading (1 setState)
    this.setState(prev => {
        const rows = [...prev.inventoryTransferItemRows];
        if (rows[rowIndex]) {
            rows[rowIndex] = { ...rows[rowIndex], stock_loading: true };
        }
        return { inventoryTransferItemRows: rows };
    });

    const params = {
        interchangeable_items_current_stock: "N",
        warehouse_id: this.state.addInventoryTransferForm.warehouse_from,
        need_weighted_average_cost : 'Y'
    };

    HttpAPICall.withAthorization('GET', `${this.itemCurrentStockUrl}/${item_id}`, this.props.access_token, params, {}, (resp) => {
        const respData = resp.data;
        const stockList = respData.current_stock || [];

        const current_stocks = stockList.map(cs => ({
            stock: cs,
            batch_number: cs.batch_number || batch_number || null,
            expiry_date: cs.expiry_date_display || expiry_date || null,
            qty: cs.qty,
            free_qty: cs.free_qty
        }));

        // Recompute display rate from current stock values so item-search rows don't stay at 0.
        let recalculatedRate = null;
        if (this.state.isc_item_weighted_average_cost == 'Y' && stockList.length > 0) {
            const sum = stockList.reduce((s, st) => {
                const value = parseFloat(
                    st?.weighted_average_cost ?? st?.stock?.weighted_average_cost ?? NaN
                );
                return s + (isNaN(value) ? 0 : value);
            }, 0);
            recalculatedRate = Number(Number(sum / stockList.length).toFixed(2));
        }

        // Get current row data to check for edit mode
        const currentRow = this.state.inventoryTransferItemRows[rowIndex];
        
        // Handle edit mode - adjust stock quantities
        let adjustedStocks = current_stocks;
        let editModeSelectedBatches = [];
        
        if (this.state.inventoryData && currentRow?.selected_batch_list) {
            editModeSelectedBatches = currentRow.selected_batch_list;
            
            adjustedStocks = current_stocks.map(cs => {
                // Find if this batch was selected in the original transfer
                const selectedBatch = editModeSelectedBatches.find(b => {
                    // Handle null/undefined cases
                    const batchMatch = b.batch_number === cs.stock.batch_number;
                    const expiryMatch = b.expiry_date === cs.stock.expiry_date;
                    
                    if (b.batch_number === null || b.batch_number === undefined) {
                        return b.expiry_date === cs.stock.expiry_date;
                    }
                    if (b.expiry_date === null || b.expiry_date === undefined) {
                        return b.batch_number === cs.stock.batch_number;
                    }
                    return batchMatch && expiryMatch;
                });
                
                if (selectedBatch) {
                    // Add back the allocated quantity for edit mode
                    return {
                        ...cs,
                        stock: {
                            ...cs.stock,
                            free_qty: cs.stock.free_qty + (selectedBatch.qty || 0),
                            qty: cs.stock.qty + (selectedBatch.qty || 0)
                        },
                        free_qty: cs.free_qty + (selectedBatch.qty || 0),
                        qty: cs.qty + (selectedBatch.qty || 0)
                    };
                }
                return cs;
            });
        }

        // Determine selected stock (preserve existing logic)
        let selectedStock = null;

        if (preSelected) {
            selectedStock = adjustedStocks.find(
                s => s.batch_number == preSelected.batch_number &&
                    s.expiry_date == preSelected.expiry_date
            ) || preSelected;
        } else if (adjustedStocks.length === 1) {
            selectedStock = adjustedStocks[0];
        }

        const autoSelectedBatch =
            adjustedStocks && adjustedStocks.length === 1
                ? [{
                    batch_number: adjustedStocks[0].batch_number ?? null,
                    expiry_date: adjustedStocks[0].expiry_date ?? null,
                    qty: adjustedStocks[0].free_qty,
                    expiry_date_display: adjustedStocks[0]?.stock?.expiry_date_display,
                    stock_id: adjustedStocks[0]?.stock?.stock_id || adjustedStocks[0]?.stock?.id || null,
                    weighted_average_cost: this.state.isc_item_weighted_average_cost == 'Y' ? (adjustedStocks[0]?.stock?.weighted_average_cost ?? null) : undefined
                }]
                : [];

        // Update only 1 row (1 setState)
        this.setState(prev => {
            const rows = [...prev.inventoryTransferItemRows];
            if (!rows[rowIndex]) return null;


            rows[rowIndex] = {
                ...rows[rowIndex],
                current_stocks: adjustedStocks,
                selected_stock: selectedStock,
                selected_batch_list: autoSelectedBatch,
                qty_without_batch: adjustedStocks.length === 1 ? adjustedStocks[0].qty : 0,
                freeqty_without_batch: adjustedStocks.length === 1 ? adjustedStocks[0].free_qty : 0,
                rate: Number.isFinite(Number(recalculatedRate)) && this.state.isc_item_weighted_average_cost == 'Y' ? Number(recalculatedRate) : Number(rows[rowIndex].rate || 0),
                amount: Number(rows[rowIndex].qty || 0) * (Number.isFinite(Number(recalculatedRate)) ? Number(recalculatedRate) : Number(rows[rowIndex].rate || 0)),
                allApiCallsCompleted: true,
                stock_loading: false,
            };
            

            return { inventoryTransferItemRows: rows };
        }, () => {
            // Calculate qty based on indent after stock is loaded
            this.calculateAndUpdateItemQty(rowIndex);
            this.handleButtonEnable();
        });
    });
};


    handleButtonEnable = () => {
        const allApiCallsCompleted = this.state.inventoryTransferItemRows.filter(i => i?.item ? true : false).every(item => item.allApiCallsCompleted);
        this.setState({ buttonDisabled: !allApiCallsCompleted });
    };

    checkAllBatchList = () => {
        const allCheckboxCollections = document.getElementsByClassName('batch_expiry_checkbox');
        const isChecked = document.getElementById('all_batch_list_check').checked;

        if (allCheckboxCollections && allCheckboxCollections.length > 0) {
            for (let i = 0; i < allCheckboxCollections.length; i++) {
                allCheckboxCollections[i].checked = isChecked;
            }
        }
    }
      
    submitBatchFormSubmit           =       (e)      =>      {
        e.preventDefault();
        let allBatchCheckboxCollections     =   document.getElementsByClassName('batch_expiry_checkbox');
        let selectedStockList               =   [];
        let seenBatchCombinations           =   new Set(); // Track to prevent duplicates

        if(allBatchCheckboxCollections && allBatchCheckboxCollections.length > 0) {
            for (let i = 0; i < allBatchCheckboxCollections.length; i++) {
                if(allBatchCheckboxCollections[i].checked) {
                    // let batch_number            =   allBatchCheckboxCollections[i].value ? allBatchCheckboxCollections[i].value : null;
                    let batch_number            =   allBatchCheckboxCollections[i].getAttribute('data-batch_number');
                    let expiry_date             =   allBatchCheckboxCollections[i].getAttribute('data-expiry_date');
                    let expiry_date_value       =   expiry_date ? expiry_date : null;

                    // Create unique key for this batch combination
                    let batchKey = JSON.stringify({
                        batch_number: batch_number,
                        expiry_date: expiry_date_value
                    });
                    
                    // Skip if we've already added this batch combination
                    if (seenBatchCombinations.has(batchKey)) {
                        continue;
                    }

                    let stockData = this.state.selectedItemStocks.find(st => {
                            let stock_batch_number = st.stock.batch_number ? st.stock.batch_number : null;
                            let stock_expiry_date = st.stock.expiry_date ? st.stock.expiry_date : null;
                            return stock_batch_number == batch_number && stock_expiry_date == expiry_date_value;
                    });
                    if (stockData) {
                        selectedStockList.push(stockData);
                        seenBatchCombinations.add(batchKey); // Mark this combination as seen
                    }
                }
            }
        
    }

  
        if(selectedStockList && selectedStockList.length == 0){
            toast.error('Please select atleasts once Item ', { position: toast.POSITION.TOP_RIGHT })
        }else{
           
            if(!selectedStockList.includes(undefined)){
                let total_qty = selectedStockList && selectedStockList.length > 0 ? selectedStockList.reduce((sum, a) => sum + parseFloat(a?.new_qty ?? 0), 0) : [];

                let inventoryTransferItemRows = this.state.inventoryTransferItemRows;

                if (inventoryTransferItemRows[this.state.selectedItemRow]?.indent_id && total_qty > inventoryTransferItemRows[this.state.selectedItemRow]?.pending_qty) {
                    toast.error('Total Quantity should not be greater than Pending Qty ', { position: toast.POSITION.TOP_RIGHT })
                } else {
                    const selectedBatchList = selectedStockList && selectedStockList.length > 0 ? selectedStockList.map(st => ({
                        batch_number: st.stock.batch_number,
                        expiry_date: st.stock.expiry_date,
                        qty: parseFloat(st.new_qty || 0),
                        expiry_date_display: st?.stock?.expiry_date_display,
                        stock_id: st.stock?.stock_id || st.stock?.id || null,
                        weighted_average_cost: this.state.isc_item_weighted_average_cost == 'Y' ? (st.stock?.weighted_average_cost ?? null) : undefined
                    })) : [];

                    // Unit rate from selected batch(es): single batch -> that WAC, multiple -> simple average of selected WACs.
                    let nextRate = Number(inventoryTransferItemRows[this.state.selectedItemRow]?.rate || 0);
                    if (this.state.isc_item_weighted_average_cost == 'Y' && selectedBatchList.length > 0) {
                        const validWac = selectedBatchList
                            .map(b => parseFloat(b.weighted_average_cost ?? NaN))
                            .filter(v => !isNaN(v));

                        if (validWac.length > 0) {
                            const sumWac = validWac.reduce((s, v) => s + v, 0);
                            nextRate = Number((sumWac / validWac.length).toFixed(2));
                        }
                    }

                    inventoryTransferItemRows[this.state.selectedItemRow] = {
                        ...inventoryTransferItemRows[this.state.selectedItemRow],
                        qty: selectedStockList && selectedStockList.length > 0 ? selectedStockList.reduce((sum, a) => sum + parseFloat(a?.new_qty ?? 0), 0) : [],
                        rate: Number.isFinite(Number(nextRate)) ? Number(nextRate) : 0,
                        amount: (selectedStockList && selectedStockList.length > 0 ? selectedStockList.reduce((sum, a) => sum + parseFloat(a?.new_qty ?? 0), 0) : 0) * (Number.isFinite(Number(nextRate)) ? Number(nextRate) : 0),
                        selected_batch_list: selectedBatchList
                    };
                   
                    this.setState({ inventoryTransferItemRows: inventoryTransferItemRows });
                    this.selectItemBatchModal.hide();

                }
            }
             
             
         }
    }

    //****************Pick Item from Indent*********************** */
    pickIndentItemModalInit         =       ()          =>      {
        this.pickIndentItemModal.show();
        if (!this.state.listingLoaded) {
            this.getAllApprovedIndentItemList();
        }
    }

    getAllApprovedIndentItemList           =       (page = 1)        =>      {
        this.setState({approved_indent_listing : true})
        let obj = {};
        if(this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y'){
            obj = {min_purchase_qty : 0.01,search_transaction_id : this.state.indent_transaction_id}
        }else{
            obj = {min_pending_qty : 0.01}
        }

        let params      =  {
            search_dispatching_warehouse : this.state.addInventoryTransferForm.warehouse_from ,
            search_warehouse_id : this.state.addInventoryTransferForm.warehouse_to,
            ...obj,
            page:page
        }
        HttpAPICall.withAthorization('GET',  this.warehouseIndentItemWiseUrl, this.props.access_token, {...params}, {}, (response) => {
            let respData            =       response.data;
            
            this.setState({
                indent_listing      :       [...this.state.indent_listing, ...respData.data],
                indnetListingMeta         :       {
                        from            :           respData.from,
                        to               :          respData.to,
                        total            :          respData.total,
                        last_page        :          respData.last_page,
                        current_page    :           respData.current_page
                    ,
                },
                totalIndentListingCount   :       respData.total,
                listingLoaded              :       true
        },() => {
           
            if(this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y' && this.state.indent_listing && this.state.indent_listing.length > 0){
              
                let item_ids = [],item_data_ids=[];

                item_data_ids   =   this.state.indent_listing.map(it => it.item.id);
                item_ids        =   this.state.indent_listing.map(it => {return({indent_id: it.transaction_id ,item_id:it.item.id})});

                this.getItemDetailsForEachIndent(item_data_ids, item_ids)
            }
        });
        }).then(() => this.setState({ approved_indent_listing :false}));
    }

    checkAllIndentItemList() {
        let indentItemForCheckbox      =   document.getElementsByClassName('indent_list_id_checkbox')
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                indentItemForCheckbox[i].checked = document.getElementById('all_indent_list_check').checked;
            }
        }
    }

    submitPickIndentFormSubmit          =   (e)         =>      {
        e.preventDefault();
        let item_ids                           =    [];
        let indentItemForCheckbox      =   document.getElementsByClassName('indent_list_id_checkbox');
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                if(indentItemForCheckbox[i].checked) {
                    item_ids.push({
                        indent_id       :        indentItemForCheckbox[i].value,
                        item_id         :        indentItemForCheckbox[i].getAttribute("data-itemId"),
                    })
                }
            }
        }
        
        if (item_ids.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
        }else {
            let item_data_ids                    =       item_ids.map(i => {return(i.item_id)})
            this.getItemDetailsForEachIndent(item_data_ids,item_ids)
          
            this.pickIndentItemModal.hide();
            //this.addNewItemRow()
           
        }
    }

    refreshIndentForAllItems = (callback = null) => {
        const rows = this.state.inventoryTransferItemRows.filter(r => r.item);
        
        if (rows.length === 0) {
            if (callback) callback();
            return;
        }

        let item_data_ids = rows.map(r => r.item.id);
        let item_ids = rows.map(r => ({
            indent_id: "",     // reset indent
            item_id: r.item.id
        }));

        HttpAPICall.withAthorization(
            "GET",
            this.itemsUrl,
            this.props.access_token,
            { item_ids: item_data_ids,
                need_weighted_average_cost : this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N',
                 indent_transaction_ids: rows.filter(i => i.indent_transaction_id !== "").map(i => i.indent_transaction_id),
                current_stock:'Y',warehouse_id :this.state.addInventoryTransferForm.warehouse_from,  need_indent: "Y",
                indent_warehouse_id:this.state.addInventoryTransferForm.warehouse_to },
            {},
            (resp) => {

                const respData = resp.data;
                let updatedRows = [...this.state.inventoryTransferItemRows];

                rows.forEach((r, index) => {
                    let indentList = respData.data.find(i => i.id == r.item.id);

                    updatedRows[index] = {
                        ...updatedRows[index],
                        item: indentList,
                        all_available_indent: indentList.indent_item_list?.map(i => ({
                            value: i.transaction_id,
                            label: i.transaction_id,
                            selectedIndentId: i
                        })) || [],
                        indent_id: "",
                        pending_qty: 0,
                        indent_qty: 0,
                        transaction_date: "",
                       
                        // selected_batch_list: [], // Clear batch selection
                    qty: this.state.fromVoucher == true ? r.qty : 0 // Reset qty
                    };
                });

                this.setState(
                    { inventoryTransferItemRows: updatedRows, listingLoaded                   :   false,
                    indent_listing                  :   [],
                    totalIndentListingCount         :   0,
                    indnetListingMeta               :   null },
                    () => {
                        updatedRows.forEach((row, index) => {
                            if (row.current_stocks && row.current_stocks.length > 0) {
                                this.calculateAndUpdateItemQty(index);
                            }
                        });
                        callback && callback()
                    }
                );
            }
        );
    };



    getItemDetailsForEachIndent     =       (item_data_ids = [],item_ids=[])      =>      {

       let params = {item_ids : item_data_ids,
        need_indent : 'Y',
        current_stock : 'Y',
        warehouse_id : this.state.addInventoryTransferForm.warehouse_from,
        indent_transaction_ids: item_ids.filter(i => i.indent_id !== "").map(i => i.indent_id),
                need_weighted_average_cost : this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N',
        indent_warehouse_id:this.state.addInventoryTransferForm.warehouse_to}; 
       let obj = {};
       if(this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y'){
         obj['min_purchase_qty'] = 0.01;
       }
        HttpAPICall.withAthorization('GET', this.itemsUrl, this.props.access_token, {...params,...obj}, {}, (resp) => {
            let respData                        =       resp.data;
            let inventoryTransferItemRows       =       this.state.inventoryTransferItemRows;
            let inventory_itemRow               =       this.state.inventoryTransferItemRows.filter(i => i.item ? true  :false);;
            
            item_ids.forEach((itemRow,key) => {
                let itemkey                 =   this.state.inventoryTransferItemRows.length > 1? inventory_itemRow.length + key : key;
                let indentList              =   respData.data.find(i => i.id == itemRow.item_id);
               
                let selectedIndentId        =   indentList.indent_item_list &&   indentList.indent_item_list.length > 0 ? indentList.indent_item_list.find(i => i.transaction_id == itemRow.indent_id )    : null;   
               
                let pending_qty             =   0;
                if(selectedIndentId && selectedIndentId.pending_qty && this.state.addInventoryTransferForm.fullfill_purchase_qty == 'N'){
                    pending_qty =   selectedIndentId.pending_qty;
                }else if(selectedIndentId && selectedIndentId.purchase_qty && this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y'){
                    pending_qty =   selectedIndentId.purchase_qty;
                }
                 let current_stocks = [];
                let qty_without_batch = 0;
                let freeqty_without_batch = 0;
                
                if (indentList.current_stock) {
                    current_stocks = indentList.current_stock.map(st => ({
                        stock: {
                            ...st,
                            id: st.stock_id || st.id,
                            expiry_date_display: st.expiry_date
                        },
                        batch_number: st.batch_number,
                        expiry_date: st.expiry_date,
                        qty: Number(st.qty),
                        free_qty: Number(st.free_qty)
                    }));

                    qty_without_batch = current_stocks.reduce((sum, cs) => sum + cs.qty, 0);
                    freeqty_without_batch = current_stocks.reduce((sum, cs) => sum + cs.free_qty, 0);
                }
                let computedRate = 0;
                if (this.state.isc_item_weighted_average_cost == 'Y') {
                    const stocks = indentList.current_stock || [];
                    if (stocks.length > 0) {
                        const sum = stocks.reduce((s, st) => {
                            const v = parseFloat(st.weighted_average_cost ?? NaN);
                            return s + (isNaN(v) ? 0 : v);
                        }, 0);
                        computedRate = Number(Number(sum / stocks.length).toFixed(2));
                    } else {
                        computedRate = Number(Number(indentList.weighted_average_cost ?? 0).toFixed(2));
                    }
                } else {
                    computedRate = indentList.consumption_price ? indentList.consumption_price : 0;
                }

                let row     =   {...inventoryTransferItemRows[itemkey],
                                    item                 :       indentList,
                                    all_available_indent :       indentList.indent_item_list &&   indentList.indent_item_list.length > 0 ? indentList.indent_item_list.map(list => {return({value:list.transaction_id,label:list.transaction_id,selectedIndentId : selectedIndentId})}) : [] ,
                                    indent_id            :        selectedIndentId && selectedIndentId?.transaction_id ? selectedIndentId?.transaction_id : '',
                                    indent_qty           :        selectedIndentId && selectedIndentId.indent_qty ? selectedIndentId.indent_qty : 0, 
                                    pending_qty          :        pending_qty,
                                    transaction_date     :          selectedIndentId && selectedIndentId.transaction_date_display ? selectedIndentId.transaction_date_display : 0,
                                    rate                 :       computedRate,
                                    qty                  :        pending_qty ,
                                  current_stocks,
                    qty_without_batch,
                    freeqty_without_batch,
                                };
                inventoryTransferItemRows[itemkey]            =   row;
                let allInventoryTransferItemRows        =       inventoryTransferItemRows.filter(i => i.item ? true : false)
                const uniqueInventoryTransferRows = allInventoryTransferItemRows.filter((item, index, self) => {
                    const pos = self.findIndex((i) => i?.indent_id === item?.indent_id && i.item.id === item.item.id);
                    return pos === index;
                });
                this.setState({ inventoryTransferItemRows: uniqueInventoryTransferRows })
                // if (indentList.category == 'goods') {
                //     //load Inventory Level of this item at given warehouse for this key :-
                //     this.getItemInventoryLevel(indentList.id, itemkey);
                // }
            })
             
    
     
        })
    }
    
    
    onBatchChange                       =   (selectedOption, key)  =>  {
        if(selectedOption && selectedOption.stock) {
            let selected_stock              =   selectedOption.stock;
           
            let inventoryTransferItemRows         =   this.state.inventoryTransferItemRows;
            const existingRow = inventoryTransferItemRows[key] || {};
            const item = existingRow.item || {};

            // Update rate to stock-level weighted average if enabled
            let newRate = existingRow.rate || 0;
            if (this.state.isc_item_weighted_average_cost == 'Y') {
                newRate = selected_stock.weighted_average_cost ?? item.weighted_average_cost ?? newRate;
            }

            inventoryTransferItemRows[key] = {
                ...inventoryTransferItemRows[key],
                selected_stock: selected_stock,
                stock_qty: selected_stock.qty,
                free_qty: selected_stock.free_qty,
                stock_id: selectedOption.stock_id ? selectedOption.stock_id : null,
                rate: Number(newRate || 0),
                amount: Number(newRate || 0) * Number(existingRow.qty || 0)
            };

            this.setState({ inventoryTransferItemRows: [...inventoryTransferItemRows] }, async () => {
                // Convert rate if currency differs
                const fromCurrency = existingRow.source_currency || item.consumption_currency || this.state.defaultCurrency || 'INR';
                const toCurrency = this.state.defaultCurrency || 'INR';
                if (this.state.isc_item_weighted_average_cost == 'Y' && fromCurrency && toCurrency && fromCurrency !== toCurrency && Number(newRate) > 0) {
                    try {
                        const converted = await this.convertCurrencyWithAPI(Number(newRate), fromCurrency, toCurrency);
                        inventoryTransferItemRows[key] = {
                            ...inventoryTransferItemRows[key],
                            rate: Number(converted || newRate),
                            amount: Number(converted || newRate) * Number(inventoryTransferItemRows[key].qty || 0),
                            converted_currency: toCurrency
                        };
                        this.setState({ inventoryTransferItemRows: [...inventoryTransferItemRows] });
                    } catch (e) {
                        console.error('Rate conversion failed on batch change (transfer)', e);
                    }
                }
            });
        }

        if(selectedOption && selectedOption.batch_number || selectedOption && selectedOption.expiry_date){
            let inventoryTransferItemRows         =   this.state.inventoryTransferItemRows;
            inventoryTransferItemRows[key]        =   {
                ...inventoryTransferItemRows[key], 
                batch_number    :   selectedOption.batch_number ? selectedOption.batch_number : null,
                expiry_date     :   selectedOption.expiry_date ? selectedOption.expiry_date : null,
                stock_id        :   selectedOption.stock_id ? selectedOption.stock_id : null,
            };
            this.setState({inventoryTransferItemRows : [...inventoryTransferItemRows]});
        }
    }

    addItemsfromSearch          =       (selectedItems)     =>  {
       
        let allRows = this.state.inventoryTransferItemRows ?  this.state.inventoryTransferItemRows.filter(i => i.item ? true : false) : [];
        const baseIndex = allRows.length;

        // Batch fetch full item details (with current_stock and weighted average) for selected items
        const itemIds = selectedItems.map(s => s.item.id);
        const params = {
            item_ids: itemIds,
            current_stock: 'Y',
            need_weighted_average_cost: this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N',
            warehouse_id: this.state.addInventoryTransferForm.warehouse_from,
            per_page: 50
        };

        HttpAPICall.withAthorization('GET', this.itemsUrl, this.props.access_token, params, {}, (resp) => {
            const apiItems = resp?.data?.data || [];

            selectedItems.forEach((itemData, idx) => {
                const key = baseIndex + idx;
                const fullItem = apiItems.find(i => String(i.id) === String(itemData.item.id)) || itemData.item;

                // Call onItemSelect with enriched itemdata and provided qty/rate
                this.onItemSelect({...itemData, itemdata: fullItem, item: fullItem}, key, itemData.qty, itemData.rate, true);
            });
        }, (err) => {
            // On error, fallback to original selected items
            selectedItems.forEach((itemData, idx) => {
                const key = baseIndex + idx;
                this.onItemSelect({...itemData, itemdata: itemData.item, item: itemData.item}, key, itemData.qty, itemData.rate, true);
            });
        });
    }

    transferBulkUploadModalInit = () => {
    document.getElementById("addTransferFileSelector").value = null;

    this.transferBulkUploadModal.show();
  };

    transferBulkUploadFormSubmit = (event) => {
        event.preventDefault();
        this.setState({ transferBulkUploadFormSubmiting: true });

        const formElement = document.getElementById("transferBulkUploadForm");
        const formData = new FormData(formElement);

        // Add warehouse IDs to FormData
        formData.append('warehouse_from', this.state.addInventoryTransferForm.warehouse_from);
        formData.append('warehouse_to', this.state.addInventoryTransferForm.warehouse_to);
         formData.append('need_weighted_average_cost', this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N');

        const headers = {
            'Authorization': 'Bearer ' + this.props.access_token,
        };

        api.server2Api.post(
            ISC_INV_TRANSFER_URL + '/item_upload_by_excel',
            formData,
            { headers: headers }
        )
            .then((response) => {
               
                toast.success(response.data?.msg || "Items uploaded successfully", {
                    position: toast.POSITION.TOP_RIGHT
                });

                // Process the uploaded items and add them to the inventory transfer
                if (response.data && response.data.data) {
                    this.processUploadedItems(response.data.data);
                }
                if (response.data.generated_file && response.data.generated_file.file_path) {
                    download.file(response.data.generated_file.file_path);
                }

                this.transferBulkUploadModal.hide();
            })
            .catch((err) => {
                
                toast.error(
                    err?.response?.data?.message || "Unable to upload Item Add File.",
                    { position: toast.POSITION.TOP_RIGHT }
                );
            })
            .finally(() => {
                this.setState({ transferBulkUploadFormSubmiting: false });
            });
    }

    processUploadedItems = async (uploadedItems) => {
    if (!uploadedItems || uploadedItems.length === 0) {
        toast.error("No items found in the uploaded file", { 
            position: toast.POSITION.TOP_RIGHT 
        });
        return;
    }

    // Show loading state
    this.setState({ loading_item: true });

    const defaultCurrency = this.props.defaultCurrency || this.state.defaultCurrency || "INR";

    const calculateSimpleAverageWac = (stocks = []) => {
        if (!stocks.length) return null;
        const values = stocks
            .map(st => parseFloat(st?.weighted_average_cost ?? st?.stock?.weighted_average_cost ?? NaN))
            .filter(v => !isNaN(v));
        if (!values.length) return null;
        const sum = values.reduce((s, v) => s + v, 0);
        return Number((sum / values.length).toFixed(2));
    };

    const getDisplayRateForUploadedRow = async (itemData, formattedCurrentStocks = []) => {
        let rate = 0;
        if (this.state.isc_item_weighted_average_cost == 'Y') {
            const avgWacFromCurrentStock = calculateSimpleAverageWac(itemData?.current_stock || []);
            const avgWacFromFormatted = calculateSimpleAverageWac(formattedCurrentStocks || []);
            rate = avgWacFromCurrentStock ?? avgWacFromFormatted ?? Number(itemData?.weighted_average_cost || 0);
        } else {
            rate = Number(itemData?.consumption_price || 0);
        }

        const fromCurrency = itemData?.consumption_currency || defaultCurrency;
        const toCurrency = defaultCurrency;
        if (rate > 0 && fromCurrency !== toCurrency) {
            try {
                rate = await this.convertCurrencyWithAPI(rate, fromCurrency, toCurrency);
            } catch (error) {
                console.error('Currency conversion failed for item:', itemData?.id, error);
            }
        }

        return Number(Number(rate || 0).toFixed(2));
    };
    
    // Process all items with currency conversion
    const newItemRowsPromises = uploadedItems.map(async (uploadedItem) => {
        const itemData = uploadedItem.item_data;
        const currentStock = itemData.current_stock || [];
        
        // Prepare indent data
        const indentItemList = itemData.indent_item_list || [];
        
        // Find stock in the current warehouse
        let formattedCurrentStocks = [];
        let selectedStock = null;
        let qty_without_batch = 0;
        let freeqty_without_batch = 0;
        let totalStockQty = 0; // Total available stock quantity
        let availableBatchQty = 0; // Specific batch quantity
        
        // Check if selected_stock is provided from API
        const apiSelectedStock = uploadedItem.selected_stock;
        
        if (currentStock.length > 0) {
            formattedCurrentStocks = currentStock.map(stock => {
                // Check if this stock matches the uploaded batch
                const matchesBatch = (
                    stock.batch_number === uploadedItem.batch_number &&
                    stock.expiry_date === uploadedItem.expiry_date
                );
                
                const stockObj = {
                    stock: {
                        ...stock,
                        expiry_date_display: stock.expiry_date,
                        id: stock.stock_id || stock.id
                    },
                    batch_number: stock.batch_number,
                    expiry_date: stock.expiry_date,
                    qty: stock.qty,
                    free_qty: stock.free_qty
                };
                
                // If this is the warehouse stock
                if (stock.warehouse_id == this.state.addInventoryTransferForm.warehouse_from) {
                    qty_without_batch = stock.qty;
                    freeqty_without_batch = stock.free_qty;
                    
                    // Calculate total stock for the warehouse
                    totalStockQty += stock.free_qty || 0;
                    
                    // If we have API selected stock, use it ONLY if it matches BOTH batch AND expiry
                    if (apiSelectedStock && 
                        apiSelectedStock.batch_number === stock.batch_number && 
                        apiSelectedStock.expiry_date === stock.expiry_date) {
                        selectedStock = {
                            stock: {
                                ...apiSelectedStock,
                                expiry_date_display: apiSelectedStock.expiry_date,
                                id: apiSelectedStock.stock_id || apiSelectedStock.id
                            },
                            batch_number: apiSelectedStock.batch_number,
                            expiry_date: apiSelectedStock.expiry_date,
                            qty: apiSelectedStock.qty,
                            free_qty: apiSelectedStock.free_qty
                        };
                        availableBatchQty = apiSelectedStock.free_qty || 0;
                    }
                    // If this is the specific batch we're looking for (fallback logic)
                    else if (matchesBatch && !selectedStock) {
                        availableBatchQty = stock.free_qty || 0;
                        selectedStock = stockObj;
                    }
                    
                    // If no specific batch was uploaded, select first available stock
                    if (!uploadedItem.batch_number && !uploadedItem.expiry_date && !selectedStock) {
                        selectedStock = stockObj;
                    }
                }
                
                return stockObj;
            });
            
            // If we have API selected stock but didn't find it in the loop above,
            // create the stock object from apiSelectedStock
            if (apiSelectedStock && !selectedStock) {
                // Check if this API stock is from the correct warehouse
                if (apiSelectedStock.warehouse_id == this.state.addInventoryTransferForm.warehouse_from) {
                    selectedStock = {
                        stock: {
                            ...apiSelectedStock,
                            expiry_date_display: apiSelectedStock.expiry_date,
                            id: apiSelectedStock.stock_id || apiSelectedStock.id
                        },
                        batch_number: apiSelectedStock.batch_number,
                        expiry_date: apiSelectedStock.expiry_date,
                        qty: apiSelectedStock.qty,
                        free_qty: apiSelectedStock.free_qty
                    };
                    
                    availableBatchQty = apiSelectedStock.free_qty || 0;
                    
                    // Add to formattedCurrentStocks if not already present
                    const stockExists = formattedCurrentStocks.some(
                        s => s.batch_number === apiSelectedStock.batch_number && 
                             s.expiry_date === apiSelectedStock.expiry_date
                    );
                    if (!stockExists) {
                        formattedCurrentStocks.push(selectedStock);
                    }
                }
            }
        }
        
        // Find selected indent based on pending qty
        let selectedIndent = null;
        let pendingQty = 0;
        if (indentItemList.length > 0) {
            // Find indent with pending qty
            selectedIndent = indentItemList.find(indent => indent.pending_qty > 0);
            if (selectedIndent) {
                pendingQty = selectedIndent.pending_qty;
            }
        }
        
        // Get uploaded quantity
        const uploadedQty = parseFloat(uploadedItem.quantity) || 0;
        
        // NEW QUANTITY LOGIC
        let finalQty = 0;
        
        // If item has indent
        if (selectedIndent && pendingQty > 0) {
            if (uploadedQty < pendingQty) {
                // Uploaded qty is less than pending qty -> show uploaded qty
                finalQty = uploadedQty;
            } else {
                // Uploaded qty is greater than or equal to pending qty -> show pending qty
                finalQty = pendingQty;
            }
            
            // Ensure we don't exceed available stock (if batch specific)
            if (availableBatchQty > 0) {
                finalQty = Math.min(finalQty, availableBatchQty);
            } else {
                finalQty = Math.min(finalQty, totalStockQty);
            }
        } 
        // No indent
        else {
            if (uploadedQty < totalStockQty) {
                // Uploaded qty is less than stock qty -> show uploaded qty
                finalQty = uploadedQty;
            } else {
                // Uploaded qty is greater than or equal to stock qty -> show stock qty
                finalQty = totalStockQty;
            }
            
            // If we have a specific batch, use batch quantity instead of total stock
            if (availableBatchQty > 0) {
                if (uploadedQty < availableBatchQty) {
                    finalQty = uploadedQty;
                } else {
                    finalQty = availableBatchQty;
                }
            }
        }
        
        // Ensure we have at least 1 if no other quantity is determined
        if (finalQty <= 0 && uploadedQty > 0) {
            finalQty = uploadedQty;
        } else if (finalQty <= 0) {
            finalQty = 1;
        }
        
        // Prepare batch information
        let selected_batch_list = [];
        const batchNumber = uploadedItem.batch_number || (apiSelectedStock && apiSelectedStock.batch_number);
        const expiryDate = uploadedItem.expiry_date || (apiSelectedStock && apiSelectedStock.expiry_date);
        
        if (batchNumber || expiryDate) {
            // Preserve uploaded batch details even when an exact stock object is not resolved.
            const matchedStock = formattedCurrentStocks.find(s => {
                const sBatch = s?.stock?.batch_number ?? s?.batch_number ?? null;
                const sExpiry = s?.stock?.expiry_date ?? s?.expiry_date ?? null;
                return String(sBatch ?? '') === String(batchNumber ?? '') && String(sExpiry ?? '') === String(expiryDate ?? '');
            });

            const resolvedStockId =
                selectedStock?.stock?.id ||
                selectedStock?.stock?.stock_id ||
                matchedStock?.stock?.id ||
                matchedStock?.stock?.stock_id ||
                apiSelectedStock?.stock_id ||
                apiSelectedStock?.id ||
                null;

            const resolvedWac = this.state.isc_item_weighted_average_cost == 'Y'
                ? (
                    selectedStock?.stock?.weighted_average_cost ??
                    matchedStock?.stock?.weighted_average_cost ??
                    apiSelectedStock?.weighted_average_cost ??
                    null
                )
                : undefined;

            // Create batch list with the calculated quantity
            selected_batch_list = [{
                batch_number: batchNumber || null,
                expiry_date: expiryDate || null,
                qty: finalQty,
                expiry_date_display: expiryDate || null,
                stock_id: resolvedStockId,
                weighted_average_cost: resolvedWac
            }];
        } else {
            // For rows without batch/expiry, keep a null/null entry so UI shows BNA.
            selected_batch_list = [{
                batch_number: null,
                expiry_date: null,
                qty: finalQty,
                expiry_date_display: null,
                stock_id: selectedStock?.stock?.id || selectedStock?.stock?.stock_id || apiSelectedStock?.stock_id || apiSelectedStock?.id || null,
                weighted_average_cost: this.state.isc_item_weighted_average_cost == 'Y'
                    ? (selectedStock?.stock?.weighted_average_cost ?? apiSelectedStock?.weighted_average_cost ?? null)
                    : undefined
            }];
        }
        
        /* ================= RATE WITH CURRENCY CONVERSION ================= */
        const rate = await getDisplayRateForUploadedRow(itemData, formattedCurrentStocks);
        
        // Create the complete item row
        return {
            ...this.iniitTransferItemRow,
            item: itemData,
            itemdata: itemData,
            qty: finalQty,
            rate: rate,  // Use converted rate
            remark: uploadedItem.notes || "",
            measuring_unit: itemData.unit_name,
            stock_loading: false,
            allApiCallsCompleted: true,
            selected_batch_list: selected_batch_list,
            current_stocks: formattedCurrentStocks,
            selected_stock: selectedStock,
            qty_without_batch: qty_without_batch,
            freeqty_without_batch: freeqty_without_batch,
            
            // Indent data
            all_available_indent: indentItemList.map(list => ({
                value: list.transaction_id,
                label: list.transaction_id,
                selectedIndentId: list
            })),
            indent_id: selectedIndent ? selectedIndent.transaction_id : "",
            indent_qty: selectedIndent ? selectedIndent.indent_qty : 0,
            transaction_date_display: selectedIndent ? selectedIndent.transaction_date_display : "",
            pending_qty: pendingQty,
            transaction_date: selectedIndent ? 
                (selectedIndent.transaction_date_display || "") : "",
                
            // Additional metadata
            stock_qty: uploadedQty,
            stock_id: selectedStock ? (selectedStock.stock.id || selectedStock.stock.stock_id) : null,
            available_batch_qty: availableBatchQty,
            total_available_stock: totalStockQty,
            
            // Store the API provided stock data for reference
            api_selected_stock: apiSelectedStock,
            weighted_average_cost: itemData.weighted_average_cost ? itemData.weighted_average_cost : 0,
            
            // Flag to track if currency conversion was applied
            is_currency_converted: (itemData.consumption_currency || defaultCurrency) !== defaultCurrency,
            original_rate: !((itemData.consumption_currency || defaultCurrency) !== defaultCurrency) ? null : (this.state.isc_item_weighted_average_cost == 'Y' ? itemData.weighted_average_cost : itemData.consumption_price || 0),
            source_currency: itemData.consumption_currency || defaultCurrency,
            target_currency: defaultCurrency
        };
    });
    
    // Wait for all currency conversions to complete
    const newItemRows = await Promise.all(newItemRowsPromises);

    const mergeBatchLists = (listA = [], listB = []) => {
        const merged = [...listA];
        listB.forEach(b => {
            const idx = merged.findIndex(x =>
                String(x.batch_number ?? '') === String(b.batch_number ?? '') &&
                String(x.expiry_date ?? '') === String(b.expiry_date ?? '') &&
                String(x.stock_id ?? '') === String(b.stock_id ?? '')
            );
            if (idx >= 0) {
                merged[idx] = {
                    ...merged[idx],
                    qty: Number(merged[idx].qty || 0) + Number(b.qty || 0),
                    weighted_average_cost: merged[idx].weighted_average_cost ?? b.weighted_average_cost
                };
            } else {
                merged.push({ ...b, qty: Number(b.qty || 0) });
            }
        });
        return merged;
    };

    const recomputeRowRate = async (row) => {
        const itemData = row.item || {};
        let rate = Number(row.rate || 0);
        if (this.state.isc_item_weighted_average_cost == 'Y') {
            const batchWacValues = (row.selected_batch_list || [])
                .map(b => parseFloat(b.weighted_average_cost ?? NaN))
                .filter(v => !isNaN(v));

            if (batchWacValues.length > 0) {
                const sum = batchWacValues.reduce((s, v) => s + v, 0);
                rate = Number((sum / batchWacValues.length).toFixed(2));
            } else {
                const stockWacValues = (itemData.current_stock || [])
                    .map(st => parseFloat(st.weighted_average_cost ?? NaN))
                    .filter(v => !isNaN(v));
                if (stockWacValues.length > 0) {
                    const sum = stockWacValues.reduce((s, v) => s + v, 0);
                    rate = Number((sum / stockWacValues.length).toFixed(2));
                } else {
                    rate = Number(itemData.weighted_average_cost || 0);
                }
            }
        } else {
            rate = Number(itemData.consumption_price || 0);
        }

        const fromCurrency = itemData.consumption_currency || defaultCurrency;
        const toCurrency = defaultCurrency;
        if (rate > 0 && fromCurrency !== toCurrency) {
            try {
                rate = await this.convertCurrencyWithAPI(rate, fromCurrency, toCurrency);
            } catch (error) {
                console.error('Currency conversion failed while recomputing merged row rate:', itemData?.id, error);
            }
        }

        const safeRate = Number(Number(rate || 0).toFixed(2));
        const safeQty = Number(row.qty || 0);
        return {
            ...row,
            rate: safeRate,
            amount: Number((safeRate * safeQty).toFixed(2))
        };
    };

    // 1) Merge uploaded rows by item id (same item + different batches => one row)
    const uploadedByItem = new Map();
    newItemRows.forEach(row => {
        const id = String(row?.item?.id || '');
        if (!id) return;
        if (!uploadedByItem.has(id)) {
            uploadedByItem.set(id, {
                ...row,
                qty: Number(row.qty || 0),
                selected_batch_list: [...(row.selected_batch_list || [])]
            });
            return;
        }

        const existing = uploadedByItem.get(id);
        uploadedByItem.set(id, {
            ...existing,
            qty: Number(existing.qty || 0) + Number(row.qty || 0),
            selected_batch_list: mergeBatchLists(existing.selected_batch_list || [], row.selected_batch_list || [])
        });
    });

    // 2) Merge uploaded rows with already present rows by item id
    const existingRows = this.state.inventoryTransferItemRows.filter(row => row.item);
    const finalRows = [...existingRows];
    let mergedIntoExistingCount = 0;

    for (const [, uploadedRowRaw] of uploadedByItem.entries()) {
        const uploadedRow = await recomputeRowRate(uploadedRowRaw);
        const existingIndex = finalRows.findIndex(r => String(r?.item?.id || '') === String(uploadedRow?.item?.id || ''));

        if (existingIndex >= 0) {
            const existing = finalRows[existingIndex];
            const mergedRowRaw = {
                ...existing,
                qty: Number(existing.qty || 0) + Number(uploadedRow.qty || 0),
                selected_batch_list: mergeBatchLists(existing.selected_batch_list || [], uploadedRow.selected_batch_list || []),
                current_stocks: existing.current_stocks && existing.current_stocks.length > 0 ? existing.current_stocks : uploadedRow.current_stocks,
                item: existing.item || uploadedRow.item,
                itemdata: existing.itemdata || uploadedRow.itemdata,
                allApiCallsCompleted: true,
                stock_loading: false
            };
            finalRows[existingIndex] = await recomputeRowRate(mergedRowRaw);
            mergedIntoExistingCount += 1;
        } else {
            finalRows.push(uploadedRow);
        }
    }

    const updatedRows = [...finalRows, { ...this.iniitTransferItemRow }];

    this.setState({
        inventoryTransferItemRows: updatedRows,
        loading_item: false,
        buttonDisabled: false
    }, () => {
        toast.success(`Successfully added ${newItemRows.length} upload entries`, {
            position: toast.POSITION.TOP_RIGHT
        });
        if (mergedIntoExistingCount > 0) {
            toast.info(`${mergedIntoExistingCount} existing item row(s) were merged with uploaded batches`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    });
};


   downloadSampleFile = () => {
      HttpAPICall.withAthorization(
        "GET",
        ISC_INV_TRANSFER_URL + "/item_upload_sample_download",
        this.props.access_token,
        {},
        {},
        (response) => {
          download.file(response.data.file_path);
          toast.success("File Downloaded Successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.transferBulkUploadModal.hide();
        }
      );
    };




    loadMoreList                    =   ()  =>  {
        if(this.state.indnetListingMeta && this.state.indnetListingMeta.current_page < this.state.indnetListingMeta.last_page) {
            // this.setState({listingLoaded : false},() => {
                this.getAllApprovedIndentItemList(this.state.indnetListingMeta.current_page + 1);
            //})
            
        }
    }

    changeReceivingShipAddressInit = () => {
    const warehouseId = this.state.addInventoryTransferForm.warehouse_to;
    
    if (!warehouseId) {
        toast.error('Please select receiving warehouse first', { position: toast.POSITION.TOP_RIGHT });
        return;
    }
    
    // Use existing warehouse data that already contains address_list
    const warehouseData = this.state.sameReceivingWarehouseAddress;
    let addressList = warehouseData?.address_list || [];
    
    // If addressList is empty, try to get it from receivingWarehouseDetail
    if (addressList.length === 0 && this.state.receivingWarehouseDetail) {
        addressList = this.state.receivingWarehouseDetail.address_list || [];
    }
    
    const currentSelectedAddress = this.state.selectedShippingAddress;
    
    this.receivingWarehouseAddressModal.show();
    
    // If we have address list, pass it directly to modal
    if (addressList.length > 0 && this.addReceivingWarehouseAddressRef.current) {
        this.addReceivingWarehouseAddressRef.current.handleModalWithAddressList(
            warehouseId,
            addressList,
            warehouseData,
            currentSelectedAddress
        );
    } else {
        // Fetch address list if not available
        this.setState({ receiving_address_loading: true });
        
        HttpAPICall.withAthorization(
            'GET',
            this.warehouseUrl + '/' + warehouseId,
            this.props.access_token,
            { need_address_list: 'Y', shipping_address: 'Y' },
            {},
            (resp) => {
                const respData = resp.data;
                const fetchedAddressList = respData.data.address_list || [];
                const fetchedWarehouseData = {
                    ...respData.data,
                    address_list: fetchedAddressList
                };
                
                this.setState({
                    receivingWarehouseAddressList: fetchedAddressList,
                    sameReceivingWarehouseAddress: fetchedWarehouseData,
                    receivingWarehouseDetail: fetchedWarehouseData
                });
                
                if (this.addReceivingWarehouseAddressRef.current) {
                    this.addReceivingWarehouseAddressRef.current.handleModalWithAddressList(
                        warehouseId,
                        fetchedAddressList,
                        fetchedWarehouseData,
                        currentSelectedAddress
                    );
                }
                
                this.setState({ receiving_address_loading: false });
            }
        ).catch(() => {
            this.setState({ receiving_address_loading: false });
        });
    }
}

   

    
   changeReceivingWarehouseAddressHandler = (id) => {
    if (id) {
        const warehouseData = this.state.sameReceivingWarehouseAddress;
        const addressList = warehouseData?.address_list || [];
        
        let selectedAddress = addressList.find(address => address.id == id) || null;
        
        if (selectedAddress) {
            this.setState({
                selectedShippingAddress: selectedAddress,
                shipping_address_id: selectedAddress.id,
            }, () => {
                // Update GST type based on selected shipping address
                const shipState = selectedAddress?.state_id;
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
                this.setState({
                    gstTypeName: shipState === dispatchState ? "GST" : "IGST"
                });
                
                // Close modal after selection
                if (this.receivingWarehouseAddressModal) {
                    this.receivingWarehouseAddressModal.hide();
                }
            });
        } else {
            this.resetToDefaultShippingAddress();
        }
    } else {
        this.resetToDefaultShippingAddress();
    }
}

resetToDefaultShippingAddress = () => {
    const warehouseData = this.state.sameReceivingWarehouseAddress;
    const addressList = warehouseData?.address_list || [];
    const defaultAddress = addressList.find(addr => addr.is_warehouse_address === "Y") || null;
    
    this.setState({
        selectedShippingAddress: defaultAddress,
        shipping_address_id: defaultAddress?.id || warehouseData?.id,
    }, () => {
        const shipState = defaultAddress?.state_id || warehouseData?.state_id;
        const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
        this.setState({
            gstTypeName: shipState === dispatchState ? "GST" : "IGST"
        });
    });
}

    changeReceivingWarehouseAddressHandler = (id) => {
        if (id) {
            // User selected a different shipping address
            const warehouseData = this.state.sameReceivingWarehouseAddress;
            const addressList = warehouseData?.address_list || [];

            let selectedAddress = addressList.find(address => address.id == id) || null;

            this.setState({
               // selectReceivingAddress: selectedAddress,
                selectedShippingAddress: selectedAddress, // Update for display
                shipping_address_id: selectedAddress?.id, // Only update shipping_address_id
                // receiving_address_id remains the warehouse address
            }, () => {
                // Update GST type based on selected shipping address
                const shipState = selectedAddress?.state_id;
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;

                this.setState({
                    gstTypeName: shipState === dispatchState ? "GST" : "IGST"
                });
            });
        } else {
            // Reset to default (warehouse address)
            const warehouseData = this.state.sameReceivingWarehouseAddress;
            const addressList = warehouseData?.address_list || [];
            const defaultAddress = addressList.find(addr =>
                addr.is_warehouse_address === "Y"
            ) || null;

            this.setState({
                //selectReceivingAddress: defaultAddress,
                selectedShippingAddress: defaultAddress,
                shipping_address_id: defaultAddress?.id || warehouseData?.id,
            }, () => {
                const shipState = defaultAddress?.state_id || warehouseData?.state_id;
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;

                this.setState({
                    gstTypeName: shipState === dispatchState ? "GST" : "IGST"
                });
            });
        }
    }

    getReceivingWarehouseAddressList = (id, page = 1, selectedAddressId = null) => {
        this.setState({ receiving_address_loading: true });

        // Use stored address_list from state
        const warehouseData = this.state.sameReceivingWarehouseAddress;
        let addressList = warehouseData?.address_list || [];

        // If addressList is empty, try to get it from the warehouse detail in state
        if (addressList.length === 0 && this.state.receivingWarehouseDetail) {
            const warehouseDetail = this.state.receivingWarehouseDetail;
            addressList = warehouseDetail.address_list || [];
        }

        // Apply search filter if needed
        let filteredAddresses = [...addressList];
        if (this.state.searchReceivingWarehouseAddress) {
            const searchTerm = this.state.searchReceivingWarehouseAddress.toLowerCase();
            filteredAddresses = addressList.filter(addr =>
                (addr.label && addr.label.toLowerCase().includes(searchTerm)) ||
                (addr.address1 && addr.address1.toLowerCase().includes(searchTerm)) ||
                (addr.city && addr.city.toLowerCase().includes(searchTerm)) ||
                (addr.gstin && addr.gstin.toLowerCase().includes(searchTerm)) ||
                (addr.pincode && addr.pincode.includes(searchTerm))
            );
        }

        let selectedAddress = null;
        if (selectedAddressId) {
            selectedAddress = filteredAddresses.find(a => a.id == selectedAddressId);
        }

        this.setState({
            receivingWarehouseAddressList: filteredAddresses,
            receivingWarehouseListingMeta: {
                total: filteredAddresses.length,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: filteredAddresses.length
            },
            totalReceivingAddressCount: filteredAddresses.length,
            selectedShippingAddress: selectedAddress || this.state.selectedShippingAddress,
            shipping_address_id: selectedAddressId || this.state.shipping_address_id,
            receiving_address_loading: false
        });
    }

    
    addReceivingWarehouseAddressInit = () => {
        this.addReceivingWarehouseAddressRef.current.addAddressModalInit(
            this.state.addInventoryTransferForm.warehouse_to
        );
    }
    
    addInventoryTransferFormSubmitHandler       =   (e)  =>  e.preventDefault()

    addInventoryTransferFormSubmitEvent         =   (e,status = 0)         =>      {
        e.preventDefault();
        if(!this.state.saveFormSubmitting) {
            let items                           =        [...this.state.inventoryTransferItemRows];
            
            // First, check for duplicates WITHIN each row's batch list
            let dublicateItemExists             =   false;
            let dublicateItemkey                =   null;
            let duplicateDetails                =   null;
            
            for (let rowIndex = 0; rowIndex < items.length; rowIndex++) {
                const item = items[rowIndex];
                if (!item?.item) continue;
                
                // Check for duplicate batches within this row
                if (item.selected_batch_list && item.selected_batch_list.length > 1 && this.state.track_batch_expiry == "Y") {
                    const batchCombinations = new Set();
                    
                    for (let batchIndex = 0; batchIndex < item.selected_batch_list.length; batchIndex++) {
                        const batch = item.selected_batch_list[batchIndex];
                        const batchKey = JSON.stringify({
                            batch_number: batch.batch_number || '',
                            expiry_date: batch.expiry_date || '',
                            indent_id: item.indent_id || ''
                        });
                        
                        if (batchCombinations.has(batchKey)) {
                            dublicateItemExists = true;
                            dublicateItemkey = rowIndex;
                            duplicateDetails = {
                                rowIndex: rowIndex,
                                batchNumber: batch.batch_number,
                                expiryDate: batch.expiry_date,
                                isDuplicateWithinRow: true
                            };
                            break;
                        }
                        batchCombinations.add(batchKey);
                    }
                    if (dublicateItemExists) break;
                }
            }
            
            // If no duplicates found within rows, check across rows
            if (!dublicateItemExists) {
                const validItems = items.filter(i => i?.item);
                const itemCombinations = new Map();
                
                for (let rowIndex = 0; rowIndex < validItems.length; rowIndex++) {
                    const item = validItems[rowIndex];
                    
                    if (item.selected_batch_list && item.selected_batch_list.length >= 1 && this.state.track_batch_expiry == "Y") {
                        for (const batch of item.selected_batch_list) {
                            const combinationKey = JSON.stringify({
                                id: item.item.id,
                                batch_number: batch.batch_number || '',
                                expiry_date: batch.expiry_date || '',
                                indent_transaction_id: item.indent_id || ''
                            });
                            
                            if (itemCombinations.has(combinationKey)) {
                                const prevRowIndex = itemCombinations.get(combinationKey);
                                dublicateItemExists = true;
                                dublicateItemkey = rowIndex;
                                duplicateDetails = {
                                    currentRow: rowIndex,
                                    previousRow: prevRowIndex,
                                    itemId: item.item.id,
                                    batchNumber: batch.batch_number,
                                    isDuplicateWithinRow: false
                                };
                                break;
                            }
                            itemCombinations.set(combinationKey, rowIndex);
                        }
                    } else {
                        const combinationKey = JSON.stringify({
                            id: item.item.id,
                            batch_number: '',
                            expiry_date: '',
                            indent_transaction_id: item.indent_id || ''
                        });
                        
                        if (itemCombinations.has(combinationKey)) {
                            const prevRowIndex = itemCombinations.get(combinationKey);
                            dublicateItemExists = true;
                            dublicateItemkey = rowIndex;
                            duplicateDetails = {
                                currentRow: rowIndex,
                                previousRow: prevRowIndex,
                                itemId: item.item.id,
                                isDuplicateWithinRow: false
                            };
                            break;
                        }
                        itemCombinations.set(combinationKey, rowIndex);
                    }
                    if (dublicateItemExists) break;
                }
            }
            
            let itemsLists                      =        items.filter(i => i?.item ? true : false).map(i => {
                if( i.selected_batch_list && i.selected_batch_list.length >= 1 && this.state.track_batch_expiry == "Y" ){
                    return(i.selected_batch_list.map(list => {
                        // Determine batch-level rate to send
                        let rateToSend = parseFloat(i.rate) || 0;
                        if (this.state.isc_item_weighted_average_cost == 'Y') {
                            const stocks = i.current_stocks || [];
                            const match = stocks.find(s => {
                                const batchMatch = (s.batch_number === list.batch_number) || (s.batch_number == null && list.batch_number == null) || (s.batch_number == undefined && list.batch_number == undefined);
                                const expiryMatch = (s.expiry_date === list.expiry_date) || (s.expiry_date == null && list.expiry_date == null) || (s.expiry_date == undefined && list.expiry_date == undefined);
                                return batchMatch && expiryMatch;
                            });

                            if (match && match.stock && match.stock.weighted_average_cost !== undefined) {
                                const w = parseFloat(match.stock.weighted_average_cost);
                                if (!isNaN(w)) rateToSend = w;
                            } else if (list.weighted_average_cost !== undefined) {
                                const lw = parseFloat(list.weighted_average_cost);
                                if (!isNaN(lw)) rateToSend = lw;
                            } else {
                                const fallback = parseFloat(i.weighted_average_cost ?? i.item?.weighted_average_cost ?? i.rate) || 0;
                                rateToSend = fallback;
                            }
                        }

                        return{

                        id                  :   i.item.id,
                        indent_transaction_id    :   i.indent_id ? i.indent_id : '',
                        batch_number             :   list.batch_number ? list.batch_number :'',
                        expiry_date              :   list.expiry_date ? list.expiry_date : "",
                        qty                      :   parseFloat(list.qty),
                        rate                     :   Number(rateToSend),
                        stock_id                 :   i.stock_id ? i.stock_id : '',
                        remark                   :   i.remark,
                        gst                      :   i.gst
                    }})) 
                }else{
                    return {id                  :   i.item.id,
                        indent_transaction_id    :   i.indent_id ? i.indent_id : '',
                        batch_number             :    '',
                        expiry_date              :   '',
                        gst                      :   i.gst,
                        qty                      :   parseFloat(i.qty),
                        rate                     :   parseFloat(i.rate),
                        stock_id                 :   i.stock_id ? i.stock_id : '',
                        remark                   :   i.remark};
                    }
                }
            )                                  
                                                            
            let allFinalItemLists        =    itemsLists.flat();                                                

            let showErrors                      =   [];

            let addInventoryTransferForm        =     {...this.state.addInventoryTransferForm,
                                                        adjustment_amount   :   parseFloat(this.state.addInventoryTransferForm.adjustment_amount)}; 
            
            let additional_attributes = {};
            this.state.formData.additional_attributes.forEach(attr => {
                const key = attr.key;
                const fieldName = "additional_attributes_" + key;
                additional_attributes[key] = this.state.additionalAttributesData[fieldName] || "";
            });
            
            let formData                        =     {...addInventoryTransferForm,
                                                      status        :       status ? status  : 0,
                                                      items         :       allFinalItemLists,
                                                    additional_attributes: additional_attributes};
            // formData.receiving_address_id = this.state.addInventoryTransferForm.warehouse_to || null;
            // formData.dispatching_address_id = this.state.addInventoryTransferForm.warehouse_from || null;

            formData.shipping_address_id = this.state.selectedShippingAddress && this.state.selectedShippingAddress.id ? this.state.selectedShippingAddress.id : null;
                                                    

            if(formData.transaction_date == '') {
                showErrors                      =   [...showErrors , 'Please enter Transaction Date.'];
            }

            if(formData.warehouse_from == '') {
                showErrors                      =   [...showErrors , 'Please select Dispatching Warehouse.'];
            }

            if(formData.warehouse_to == '') {
                showErrors                      =   [...showErrors , 'Please select Receiving Warehouse.'];
            }
            if(!formData.status && formData.status === '') {
                showErrors                      =   [...showErrors , 'Please select Status.'];
            }

            if(itemsLists.length == 0) {
                showErrors                      =   [...showErrors , 'Please select Item and their  qty.'];
            }else if(itemsLists.find(i => parseFloat(i.qty) <= 0)) {
                showErrors                      =   [...showErrors , 'Every Item\'s  qty must be more than 0.'];
            } else if(dublicateItemExists == true) {
                if (duplicateDetails?.isDuplicateWithinRow) {
                    showErrors = [...showErrors , `Duplicate batch found in row ${dublicateItemkey + 1}. Batch  with expiry date  appears more than once. Please remove duplicate entries.`];
                } else {
                    showErrors = [...showErrors , `Duplicate entry found at row ${dublicateItemkey + 1}. This item + batch + expiry combination already exists at row ${duplicateDetails?.previousRow + 1}. Please check and remove the duplicate.`];
                }
            }

            if(showErrors.length > 0) {
                toast.error(showErrors[0], {position: toast.POSITION.TOP_RIGHT});
            } else {
                 const dispatching_address_id    =   this.state.selectDispatchAddress ? this.state.selectDispatchAddress.id : null;
                // const dispatching_address       =   this.state.selectDispatchAddress ? this.state.selectDispatchAddress : null;
                 const receiving_address_id      =   this.state.selectReceivingAddress ? this.state.selectReceivingAddress.id : null;
                // const receiving_address         =   this.state.selectReceivingAddress ? this.state.selectReceivingAddress : null;


                formData                        =   {...formData,dispatching_address_id  :dispatching_address_id,receiving_address_id:receiving_address_id};
                this.setState({ saveFormSubmitting: true }, () => {
                    if(this.state.inventoryData){
                        HttpAPICall.withAthorization('PUT', this.inventoryTransferUrl, this.props.access_token, {}, formData, (response) => {
                            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT })
                            this.props.history.push({pathname: `/inventory_transfer_list`, state: {inventoryId : response.data.transaction_id }})
                        },(error) => {
                            if (error?.response?.status === 422) {

                                swal({
                                    title: "Price Update",
                                    text: "Transfer Average Rate has been changed. Kindly press OK to refresh.",
                                    icon: "warning",
                                    buttons: {
                                        confirm: "OK"
                                    }
                                }).then((confirm) => {

                                    if (confirm) {

                                        // ✅ ONLY UPDATE RATE (DO NOT TOUCH ANY OTHER FIELD)
                                        const updatedRows = this.state.inventoryTransferItemRows.map(row => {
                                            if (!row.item || !row.item.id) return row;

                                            return {
                                                ...row,
                                                rate: row.weighted_average_cost || row.rate
                                            };
                                        });

                                        this.setState({
                                            inventoryTransferItemRows: updatedRows
                                        });
                                    }
                                });

                                return; // ✅ stop further execution
                            }

                        }).then(() => this.setState({ saveFormSubmitting: false })); 
                    }else{
                        HttpAPICall.withAthorization('POST', this.inventoryTransferUrl, this.props.access_token, {}, formData, (response) => {
                            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT })
                            this.props.history.push({pathname: `/inventory_transfer_list`, state: {inventoryId : response.data.transaction_id }})
                        }).then(() => this.setState({ saveFormSubmitting: false })); 
                    }
                });
            }
         }
    }

    //*****************SHOW INDENT DETAIl***************** */

    viewIndentDetailModalInit           =       (id)        =>      {
        if(id){
            this.getIndentDetail(id)
            this.viewIndentDetailModal.show()
        }
        
    }

    getIndentDetail        =       (transaction_id)      =>      {
    
        this.setState({indent_detail_loading : true})
        HttpAPICall.withAthorization('GET', this.detailUrl + '/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                indentDetail    :   respData.data,
                indentTransId   :   respData.data.transaction_id,
           });
        
        },(err) => {
            
        }).then(() => this.setState({indent_detail_loading : false}));
   
    }


    changeWarehouseAddressModal = (warehouse_id, type) => {
        // Use existing warehouse detail data that already contains address_list (NO API CALL)
        const warehouseData = type === 'dispatch'
            ? this.state.sameDispatchWarehouseAddress
            : this.state.sameReceivingWarehouseAddress;

        const addressList = warehouseData?.address_list || [];
        const currentSelectedAddress = type === 'dispatch'
            ? this.state.selectDispatchAddress
            : this.state.selectReceivingAddress;

        if (type === 'dispatch') {
            this.setState({
                dispatchAddressModalHandle: true,
                receivingAddressModalHandle: false,
            }, () => {
                if (this.changeWarehouseAddressRef.current) {
                    this.changeWarehouseAddressRef.current.handleModalWithAddressList(
                        warehouse_id,
                        addressList,
                        warehouseData,
                        currentSelectedAddress
                    );
                }
            });
        } else {
            this.setState({
                dispatchAddressModalHandle: false,
                receivingAddressModalHandle: true,
            }, () => {
                if (this.changeWarehouseAddressRef.current) {
                    this.changeWarehouseAddressRef.current.handleModalWithAddressList(
                        warehouse_id,
                        addressList,
                        warehouseData,
                        currentSelectedAddress
                    );
                }
            });
        }
    }

    saveInventoryTransferFormJsx             =   ()  =>  {
        let sub_total_amount                    =   0;
        let gst_total_amount                    =   0;
        let gst_slab                            =   [];
        let total_amount                        =   0;
        let inventory_summary                    =   [];
        let adjustment_amount                   =   parseFloat(this.state.addInventoryTransferForm.adjustment_amount);
        
        this.state.inventoryTransferItemRows.forEach((item,key) => {
            if(item && item.item) {
                let item_amount             =   parseFloat(item.qty * item.rate);
                let discount_amout          =   0;
                let item_with_discount      =   item_amount - discount_amout;
                let tax_amount              =   0;
                
                if(item.gst && item.gst > 0 && this.state.dispatchingWarehouseDetail
                                && this.state.dispatchingWarehouseDetail.gstin) {
                    tax_amount              =   item_with_discount * item.gst / 100;
                    if(!gst_slab[item.gst]) {
                        gst_slab[item.gst]  =   [];
                    }
                    gst_slab[item.gst].push(tax_amount);
                }
                let item_final_amount       =   item_with_discount + tax_amount;
                sub_total_amount           +=   item_with_discount;
                gst_total_amount           +=   tax_amount;
                total_amount               +=   item_final_amount; 
            }
        });
      

        if(gst_total_amount > 0) {
            inventory_summary.push({key : 'Sub Total' , value : sub_total_amount.toFixed(2)});
            gst_slab.forEach((tax_amounts, gst) => {
                let total_tax = tax_amounts.reduce((sum, a) => sum + a, 0);
                if(this.state.dispatchingWarehouseDetail && this.state.receivingWarehouseDetail && this.state.dispatchingWarehouseDetail.state_id !== this.state.receivingWarehouseDetail.state_id) {
                    inventory_summary.push({key : 'IGST ' + gst + '%', value : total_tax.toFixed(2)});
                } else {
                    let tax = gst / 2;
                    inventory_summary.push({key : 'CGST ' + tax + '%', value : (total_tax/2).toFixed(2)});
                    inventory_summary.push({key : 'SGST ' + tax + '%', value : (total_tax/2).toFixed(2)});
                }
            });
        }

        let final_total_amount=Number(total_amount);
        if(adjustment_amount){
            final_total_amount = Number(total_amount) + Number(adjustment_amount) ;
        }
      
        return (<form className="bg-white p-3" onSubmit={this.addInventoryTransferFormSubmitHandler}>
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label className="form-label require">Date of Transaction</label>
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={this.state.addInventoryTransferForm.transaction_date ? moment(this.state.addInventoryTransferForm.transaction_date, 'YYYY-MM-DD').toDate() : false}
                        name="transaction_date,"
                        onChange={(value, event) => this.formDateHandler('transaction_date', value, 'addInventoryTransferForm')}
                        dateFormat="dd-MMM-yyyy"
                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        required={true}
                        disabled={this.state.isc_prevent_back_day_voucher == 'Y' ? true : false}
                        placeholderText="Please Enter Date of Transaction"
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label className="form-label require">Dispatching Warehouse</label>
                </div>
                <div className="col-sm-6">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'addInventoryTransferForm', 'warehouse_from',() => {
                                if(this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y' && selectedOption){
                                    this.getAllApprovedIndentItemList();
                                }
                            });
                            this.onDispatchingWarehouseChange(selectedOption);
                        }}
                        options={this.state.allDispatchingWarehouses.filter(dw => dw.value !== this.state.addInventoryTransferForm.warehouse_to)}
                        isSearchable={true}
                        isClearable={true}
                        required={true}
                        isDisabled={this.state.inventoryData && this.state.inventoryData.status && this.state.inventoryData.status == 36 ||
                            this.state.inventoryData && this.state.inventoryData.status && this.state.inventoryData.status == 35}
                        value={this.state.allDispatchingWarehouses.find(m => m.value == this.state.addInventoryTransferForm.warehouse_from)}
                        placeholder="Please Select Dispatching Warehouse"
                    />
                </div>
                <div className="col-sm-3">
                    {this.state.addInventoryTransferForm.warehouse_from ?
                        <Ax><button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary mx-2 pl0 pr0" style={{ height: "38px" }}>
                            <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                        </button>
                            <ul className="dropdown-menu dropdown-menu-end cursor_pointer" aria-labelledby="dropdownMenuButton1">
                                <li><Link className="dropdown-item" onClick={() => this.changeWarehouseAddressModal(this.state.addInventoryTransferForm.warehouse_from, 'dispatch')}>Change Address</Link></li>
                            </ul></Ax>
                        : null}
                </div>
            </div>
            {this.state.dispatchingWarehouseDetail
                ? <div className="row align-items-center mt1">
                    <div className="offset-3 col-sm-8"><WarehouseAddress warehouseDetail={this.state.dispatchingWarehouseDetail} /></div>
                </div>
                : (this.state.dispatchingWarehouseDetailLoading ? <Loader /> : null)
            }
            {/* Receiving Warehouse Section with Address Selection - UPDATED */}
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Receiving Warehouse</label>
                </div>
                <div className="col-sm-6">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'addInventoryTransferForm', 'warehouse_to');
                            this.onReceivingWarehouseChange(selectedOption);
                        }}
                        options={this.state.allReceivingWarehouses.filter(rw => rw.value !== this.state.addInventoryTransferForm.warehouse_from)}
                        isSearchable={true}
                        isClearable={true}
                        required={true}
                        isDisabled={this.state.inventoryData && this.state.inventoryData.status && this.state.inventoryData.status == 36}
                        value={this.state.allReceivingWarehouses.find(m => m.value == this.state.addInventoryTransferForm.warehouse_to)}
                        placeholder="Please Select Receiving Warehouse"
                    />
                </div>
                <div className="col-sm-3">
                    {this.state.addInventoryTransferForm.warehouse_to ? (
                        <Ax>
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary mx-2 pl0 pr0" style={{ height: "38px" }}>
                                <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end cursor_pointer" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <Link className="dropdown-item" onClick={() => this.changeReceivingShipAddressInit()}>
                                        Change Ship-To Address
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" onClick={() => this.addReceivingWarehouseAddressInit()}>
                                        Add Ship-To Address
                                    </Link>
                                </li>
                            </ul>
                        </Ax>
                    ) : null}
                </div>
            </div>


            {this.state.receivingWarehouseDetail ? (
                <div className="row align-items-center mt1 mb-3">
                    <div className="offset-3 col-sm-8">
                        <div className="row">
                            <div className="col-sm-6">
                                <label className="form-label">
                                    Organization: {this.state.receivingWarehouseDetail.organization ? this.state.receivingWarehouseDetail.organization.name : this.state?.orgInfoData?.group_name}
                                </label>
                                <br />
                                <label className="form-label">
                                    {this.state.receivingWarehouseDetail.label ? this.state.receivingWarehouseDetail.label + ", " : ""}
                                    <br />
                                    {this.state.receivingWarehouseDetail.address1 ? this.state.receivingWarehouseDetail.address1 + ", " : ""}
                                    <br />
                                    {this.state.receivingWarehouseDetail.address2 ? this.state.receivingWarehouseDetail.address2 + ", " : ""}
                                    <br />
                                    {this.state.receivingWarehouseDetail.landmark ? this.state.receivingWarehouseDetail.landmark + ", " : ""}
                                    <br />
                                    {this.state.receivingWarehouseDetail.city ? this.state.receivingWarehouseDetail.city : ""}
                                </label>
                                <br />
                                <label className="form-label">
                                    State: {this.state.receivingWarehouseDetail.state ? this.state.receivingWarehouseDetail.state.name : ""}
                                </label>
                                <br />
                                <label className="form-label">
                                    GSTIN: {this.state.receivingWarehouseDetail.gstin ? this.state.receivingWarehouseDetail.gstin : ""}
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <div><b>Ship To Address</b></div>
                                {this.state.selectedShippingAddress ? (
                                    <Ax>
                                        <label className="form-label">
                                            {this.state.selectedShippingAddress.label ? <span>{this.state.selectedShippingAddress.label} <br /></span> : ""}
                                            {this.state.selectedShippingAddress.address1 ? <span>{this.state.selectedShippingAddress.address1}, <br /></span> : ""}
                                            {this.state.selectedShippingAddress.address2 ? <span>{this.state.selectedShippingAddress.address2}, <br /></span> : ""}
                                            {this.state.selectedShippingAddress.landmark ? <span>{this.state.selectedShippingAddress.landmark}, <br /></span> : ""}
                                            {this.state.selectedShippingAddress.city ? <span>{this.state.selectedShippingAddress.city}, </span> : ""}
                                        </label>
                                        <br />
                                        {this.state.selectedShippingAddress && this.state.selectedShippingAddress.state_name ? (
                                            <Ax>
                                                <label className="form-label">
                                                    State: <span>{this.state.selectedShippingAddress.state_name}</span>
                                                </label>
                                                <br />
                                            </Ax>
                                        ) : ""}
                                        {this.state.selectedShippingAddress && this.state.selectedShippingAddress.gstin ? (
                                            <Ax>
                                                <label className="form-label">
                                                    GSTIN: <span>{this.state.selectedShippingAddress.gstin}</span>
                                                </label>
                                            </Ax>
                                        ) : ""}
                                    </Ax>
                                ) : (
                                    <Ax>
                                        <label className="form-label">
                                            {this.state.receivingWarehouseDetail.label ? <span>{this.state.receivingWarehouseDetail.label} <br /></span> : ""}
                                            {this.state.receivingWarehouseDetail.address1 ? <span>{this.state.receivingWarehouseDetail.address1}, <br /></span> : ""}
                                            {this.state.receivingWarehouseDetail.address2 ? <span>{this.state.receivingWarehouseDetail.address2}, <br /></span> : ""}
                                            {this.state.receivingWarehouseDetail.landmark ? <span>{this.state.receivingWarehouseDetail.landmark}, <br /></span> : ""}
                                            {this.state.receivingWarehouseDetail.city ? <span>{this.state.receivingWarehouseDetail.city}, </span> : ""}
                                        </label>
                                        <br />
                                        {this.state.receivingWarehouseDetail && this.state.receivingWarehouseDetail.state ? (
                                            <Ax>
                                                <label className="form-label">
                                                    State: <span>{this.state.receivingWarehouseDetail.state.name}</span>
                                                </label>
                                                <br />
                                            </Ax>
                                        ) : ""}
                                        {this.state.receivingWarehouseDetail && this.state.receivingWarehouseDetail.gstin ? (
                                            <label className="form-label">
                                                GSTIN: <span>{this.state.receivingWarehouseDetail.gstin}</span>
                                            </label>
                                        ) : ""}
                                    </Ax>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (this.state.receivingWarehouseDetailLoading ? <div className="offset-3 col-sm-8"><Loader /></div> : null)}
           <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Status</label>
                </div>
                <div className="col-sm-4">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'addInventoryTransferForm', 'status', () => {
                                this.setState({
                                    addInventoryTransferForm: { ...this.state.addInventoryTransferForm, date_of_dispatch: '', date_of_receive: '' }
                                })
                            });
                        }}
                        options={this.state.allStatus}
                        required={true}
                        isDisabled={this.state.inventoryData}
                        value={this.state.allStatus.find(m => m.value == this.state.addInventoryTransferForm.status)}
                        placeholder="Please Select Status"
                    />
                </div>

            </div>
            {(this.state.addInventoryTransferForm.status == 35 || this.state.addInventoryTransferForm.status == 36) && !this.state.inventoryData && <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Date of Dispatch</label>
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={this.state.addInventoryTransferForm.date_of_dispatch ? moment(this.state.addInventoryTransferForm.date_of_dispatch, 'YYYY-MM-DD').toDate() : false}
                        name="date_of_dispatch"
                        onChange={(value, event) => this.formDateHandler('date_of_dispatch', value, 'addInventoryTransferForm')}
                        dateFormat="dd-MMM-yyyy"
                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        required={true}
                        placeholderText="Please Enter Date of Dispatch"
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>}
            {this.state.addInventoryTransferForm.status == 36  && !this.state.inventoryData && <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Date of Receipt</label>
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={this.state.addInventoryTransferForm.date_of_receive ? moment(this.state.addInventoryTransferForm.date_of_receive, 'YYYY-MM-DD').toDate() : false}
                        name="date_of_receive"
                        onChange={(value, event) => this.formDateHandler('date_of_receive', value, 'addInventoryTransferForm')}
                        dateFormat="dd-MMM-yyyy"
                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                        minDate={moment(this.state.addInventoryTransferForm.date_of_dispatch, 'YYYY-MM-DD').toDate()}
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        required={true}
                        placeholderText="Please Enter Date of Receipt"
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>}
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label ">Invoice Number & Date </label>
                </div>
                <div className="col-sm-4">
                    <input
                        name="invoice_number"
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        value={this.state.addInventoryTransferForm.invoice_number}
                        onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                        placeholder="Enter Invoice/Document Number"
                    />
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={
                            this.state.addInventoryTransferForm.invoice_date
                                ? moment(this.state.addInventoryTransferForm.invoice_date, 'YYYY-MM-DD').toDate()
                                : false
                        }
                        name="invoice_date"
                        onChange={(value, event) => this.formDateHandler('invoice_date', value, 'addInventoryTransferForm')}
                        dateFormat="dd-MMM-yyyy"
                        className={"form-control"}
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        placeholderText={`Please Enter Invoice/Document Date`}

                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>
            <div>
                <AdditionalAttributeForm
                    additionalAttributes={this.state.formData?.additional_attributes || []}
                    formState={this.state.additionalAttributesData}
                    onAttributeChange={(value, attributeName) => {
                        this.setState(prev => ({
                            additionalAttributesData: {
                                ...prev.additionalAttributesData,
                                [attributeName]: value
                            }
                        }));
                    }}
                    colSpan={"col-sm-7"}
                />
            </div>
            {this.state.addInventoryTransferForm.fullfill_purchase_qty == 'N' && <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label">Item Indent</label>
                </div>
                <div className="col-sm-9">
                    <button
                        type="button"
                        disabled={this.state.addInventoryTransferForm.warehouse_from && this.state.addInventoryTransferForm.warehouse_to ? false : true}
                        className="btn btn-link text-decoration-none"
                        onClick={() => this.pickIndentItemModalInit()}
                    ><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} />  Pick Item from Approved Indent</button>
                </div>

            </div>}


            {this.inventoryTransferItemJsx()}
           
            <div className="row align-items-center mb-3">
                <div className="col-sm-6">
                    <label htmlFor="notes" className="form-label">Notes</label>
                    <textarea
                        name="notes"
                        value={this.state.addInventoryTransferForm.notes}
                        onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                        className="form-control"
                        style={{ height: "100px" }}
                    />
                </div>
                <div className="col-sm-6">
                    {/* <label htmlFor="exampleInputEmail1" className="form-label"><p> &nbsp; </p></label> */}
                    <table className="table  table-borderless mt-4">
                        <tbody>
                            {inventory_summary && inventory_summary.length > 0
                                ? (inventory_summary.map((it, k) => {
                                    return <tr className="subtotal_bg_color"><th>{it.key}</th><td className="text-end">{it.value}</td></tr>
                                }))
                                : null
                            }
                            {this.state.dispatchingWarehouseDetail && this.state.dispatchingWarehouseDetail.gstin ? null
                                : <tr className="subtotal_bg_color">
                                    <th>GST</th>
                                    <td className='float-end'>Not Applicable</td>
                                </tr>}
                            <tr className="subtotal_bg_color">
                                <th>Adjustment</th>
                                <td><input
                                    name="adjustment_amount"
                                    type="number"
                                    value={this.state.addInventoryTransferForm.adjustment_amount}
                                    onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                    className="form-control text-end"
                                    autoComplete="off"
                                    placeholder="Adjustment"
                                /></td>
                            </tr>

                            <tr className="subtotal_bg_color">
                                <th>Final Total</th>
                                <td className='float-end'>{parseFloat(final_total_amount).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {this.state.inventoryData ? null
                : <div className='mb-5'>
                    <div className="tab_content_wrapper my-1">
                        <span className="content_heading">Dispatch Details</span>

                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label ">Eway Bill Number & Date </label>
                        </div>
                        <div className="col-sm-4">
                            <input
                                name="eway_number"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.eway_number}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter Eway Number"
                            />
                        </div>
                        <div className="col-sm-4 add_calender_section">
                            <DatePicker
                                selected={
                                    this.state.addInventoryTransferForm.eway_date
                                        ? moment(this.state.addInventoryTransferForm.eway_date, 'YYYY-MM-DD').toDate()
                                        : false
                                }
                                name="eway_date"
                                onChange={(value, event) => this.formDateHandler('eway_date', value, 'addInventoryTransferForm')}
                                dateFormat="dd-MMM-yyyy"
                                className={"form-control"}
                                showMonthDropdown
                                showYearDropdown
                                autoComplete="off"
                                scrollMonthYearDropdown
                                placeholderText={`Please Enter Eway Date`}

                            />
                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label ">Docket Number & Date </label>
                        </div>
                        <div className="col-sm-4">
                            <input
                                name="document_number"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.document_number}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter Docket Number"
                            />
                        </div>
                        <div className="col-sm-4 add_calender_section">
                            <DatePicker
                                selected={
                                    this.state.addInventoryTransferForm.document_date
                                        ? moment(this.state.addInventoryTransferForm.document_date, 'YYYY-MM-DD').toDate()
                                        : false
                                }
                                name="document_date"
                                onChange={(value, event) => this.formDateHandler('document_date', value, 'addInventoryTransferForm')}
                                dateFormat="dd-MMM-yyyy"
                                className={"form-control"}
                                showMonthDropdown
                                showYearDropdown
                                autoComplete="off"
                                scrollMonthYearDropdown
                                placeholderText={`Please Enter Docket Date`}

                            />
                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label ">Transporter Name & Vehicle No.  </label>
                        </div>
                        <div className="col-sm-4">
                            <input
                                name="transporter_number"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.transporter_number}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter Transporter Number"
                            />
                        </div>
                        <div className="col-sm-4">
                            <input
                                name="vechicle_registration_no"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.vechicle_registration_no}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter vehicle Registration No"
                            />
                        </div>

                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="site_id" className="form-label ">Number of Boxes & Weight  </label>
                        </div>
                        <div className="col-sm-4">
                            <input
                                name="no_of_boxes"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.no_of_boxes}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter Number of boxes"
                            />
                        </div>
                        <div className="col-sm-2">
                            <input
                                name="weight"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={this.state.addInventoryTransferForm.weight}
                                onChange={(e) => this.formInputHandler(e, 'addInventoryTransferForm')}
                                placeholder="Enter Weight"
                            />
                        </div>
                        <div className="col-sm-2">
                            <TapSelect
                                options={this.state.allWeightUnits}
                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'addInventoryTransferForm', 'unit_of_weight')}
                                value={this.state.allWeightUnits.find(u => this.state.addInventoryTransferForm?.unit_of_weight == u.value)}
                                isSearchable={true}
                                isClearable={true}
                                placeholder="Unit"
                                menuPlacement="top"
                            />
                        </div>

                    </div>
                </div>}
            {!this.state.buttonDisabled && <div className="col-12 text-end fixed_footer">
                <button type="button" className="btn btn-secondary ms-2" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} onClick={this.closeEvent}>Cancel</button>
                <Ax>
                    <button type="button" className="btn btn-secondary ms-2" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} onClick={(e) => { this.addInventoryTransferFormSubmitEvent(e, 0); }}>
                        Save as Draft {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                    <button type="button" className="btn btn-primary ms-2" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} onClick={(e) => { this.addInventoryTransferFormSubmitEvent(e, this.state?.addInventoryTransferForm?.status); }}>
                        Save  {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </Ax>
            </div>}
        </form>);
    }

    inventoryTransferItemJsx            =       ()      =>      {
        return (<div className="my-3 row">
            <div className="col-sm-12">
                <table className="table table-bordered table-responsive bg-white ">
                    <thead className="table-secondary">
                        <tr>
                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                            <th scope="col" className="text-center" style={{ width: "30%" }}>Item Details</th>
                            <th scope="col" className="text-center" style={{ width: "14%" }}>Indent</th>
                            {this.state.track_batch_expiry == "Y" ?
                                (<th scope="col" className="text-center" style={{ width: "14%" }}>Batch Number & <br /> Expiry Date</th>)
                                : null}
                            <th scope="col" className="text-center" style={{ width: "11%" }}>Quantity</th>
                            <th scope="col" className="text-center" style={{ width: "9%" }}>Unit Rate</th>
                            <th scope="col" className="text-center" style={{ width: "7%" }}>GST</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Amount</th>
                            <th scope="col" className="" style={{ width: "7%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                       {this.state.loading_item ? <tr>
                            <td className='text-center' colSpan={8}><Loader/></td>
                       </tr> : this.state.inventoryTransferItemRows.map((itemRow, itemKey) => {
                           const editQty =
                               itemRow?.selected_batch_list?.length > 0
                                   ? itemRow.selected_batch_list.reduce((s, b) => s + Number(b.qty || 0), 0)
                                   : Number(itemRow.qty || 0);

                           const stockInHand =
                               itemRow?.current_stocks?.length > 0
                                   ? itemRow.current_stocks.reduce((s, a) => s + Number(a.stock.qty || 0), 0)
                                   : editQty;

                           const freeQty =
                               itemRow?.current_stocks?.length > 0
                                   ? itemRow.current_stocks.reduce((s, a) => s + Number(a.stock.free_qty || 0), 0) + editQty
                                   : editQty;

                           let pending_qty = itemRow?.pending_qty || 0;
                           let max_qty = freeQty >= pending_qty ? pending_qty : freeQty;
                           let item = itemRow && itemRow.item;
                            
                            return <tr className="" key={itemKey}>
                                <td className="text-center align-middle">{itemKey + 1}</td>
                                {(item
                                    ? <Ax>
                                        <td>
                                            <div className="row">
                                                <div className='col-sm-10'><span className="fw-bold link-primary cursor_pointer" onClick={() => { this.itemViewModalInit(item)}}>{item.name}</span></div>
                                                <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu">
                                                        <li className="dropdown-item" onClick={() => { this.itemViewModalInit(item) }}>View Details</li>
                                                        {this.props?.permissions?.includes('isc-item-edit') &&  <li className="dropdown-item" onClick={() => {this.setState({showItemEditModal : false},() => {this.editItemModalInit(item,itemKey)})  }}>Edit Item</li>}
                                                         <li><a href="#" className="dropdown-item" onClick={() => { this.inwardHistoryModalHandle(item, itemKey) }}>Inward History</a></li>

                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="form-text"><b>Code: </b>{itemRow.item.item_code}</div>
                                            <div className="form-text">
                                                <b>Mfr: </b>{itemRow.item.manufacturer ? itemRow.item.manufacturer.name : '-'} (<b>MPN:</b> {itemRow.item.manufacturer_part_no ? itemRow.item.manufacturer_part_no : '-'})
                                            </div>
                                            <input
                                            name="remark"
                                            type="text"
                                            value={this.state.inventoryTransferItemRows[itemKey].remark}
                                            onChange={(e) => this.dynamicInputHandlerByKey(e, itemKey, 'inventoryTransferItemRows')}
                                            className="form-control mt10"
                                            autoComplete="off"
                                            placeholder="Item Remarks"
                                        />
                                        </td>
                                        {
                                            itemRow.stock_loading && item.category == "goods"
                                                ? <td colSpan={this.state.track_batch_expiry == 'Y' ? 4 : 3}><Loader /></td>
                                                : (<Ax>
                                                    <td>
                                                        {this.state.addInventoryTransferForm.warehouse_to && itemRow && itemRow.all_available_indent && itemRow.all_available_indent.length > 0 ?
                                                            <Ax>
                                                                <TapSelect
                                                                    
                                                                    changeEvent={(selectedOption, e) => {
                                                                        const selectedStock = selectedOption?.selected_stock?.stock || null;
                                                                        const pendingQty = selectedOption?.selectedIndentId?.pending_qty || 0;

                                                                        let allRows = this.state.inventoryTransferItemRows;
                                                                        allRows[itemKey] = {
                                                                            ...this.state.inventoryTransferItemRows[itemKey],
                                                                            indent_id: selectedOption?.value,
                                                                            indent_qty: selectedOption?.selectedIndentId?.indent_qty,
                                                                            pending_qty: pendingQty,
                                                                            transaction_date: selectedOption?.selectedIndentId?.transaction_date_display,
                                                                            // Clear previous batch selection when indent changes
                                                                            selected_batch_list: [],
                                                                            qty: 0 // Reset qty
                                                                        };

                                                                        this.setState({ inventoryTransferItemRows: allRows }, () => {
                                                                            // Calculate qty based on new indent info (no API call needed)
                                                                            this.calculateAndUpdateItemQty(itemKey,false);
                                                                        });
                                                                    }}

                                                                    options={itemRow.all_available_indent}
                                                                    isSearchable={false}
                                                                    placeholder="Indent"
                                                                    isClearable={true}
                                                                    isDisabled={this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y'}
                                                                    value={itemRow.all_available_indent.find(s => s.value == this.state.inventoryTransferItemRows[itemKey].indent_id)}
                                                                />
                                                                {itemRow && itemRow.indent_qty && itemRow.indent_qty > 0
                                                                    ? <div className='py-1'>
                                                                         Date : <b> {itemRow?.transaction_date_display ? itemRow?.transaction_date_display : "-"}</b> <tapIcon.FontAwesomeIcon icon={tapIcon.faEye} onClick={() => this.viewIndentDetailModalInit(itemRow?.indent_id)} className="text-end" color="#0052CC" /> <br />
                                                                        Indent Qty : <b> {itemRow?.indent_qty ? itemRow?.indent_qty : "-"}</b> <br />
                                                                        {this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y' ? "Purchase Qty" : "Pending Qty"} : <b> {itemRow?.pending_qty ? itemRow?.pending_qty : 0}</b> <br />

                                                                    </div>
                                                                    : null}
                                                            </Ax>
                                                            : <div className='text-center'>-</div>}
                                                    </td>
                                                    
                                                    {this.state.track_batch_expiry == "Y"
                                                        ? <td className='text-center'>
                                                            <button
                                                                type="button"
                                                                onClick={() => this.selectItemBatchModalInit(itemRow.item, itemRow.current_stocks, itemRow.pending_qty, itemKey,this?.state.inventoryTransferItemRows[itemKey]?.selected_batch_list)}
                                                                className="btn btn-link text-decoration-none"
                                                                disabled={itemRow && itemRow.current_stocks && itemRow.current_stocks.length > 0 && this.state.addInventoryTransferForm.warehouse_from ? false : true}
                                                            >+ Select</button>
                                                            {this?.state.inventoryTransferItemRows[itemKey]?.selected_batch_list?.map((rl, k) => {
                                                                
                                                                return rl.qty > 0 ? <div key={k} className='text-center my-1'>{rl.batch_number && rl.expiry_date ? <span>{rl.batch_number} & {rl.expiry_date_display} : </span> : rl.batch_number && !rl.expiry_date ? <span>{rl.batch_number} : </span> : !rl.batch_number && rl.expiry_date ? <span>{rl.expiry_date_display} : </span> : <span>BNA <sup>#</sup></span>}  <b>{rl.qty}</b></div> : null
                                                            })}
                                                           
                                                        </td> : null
                                                    }
                                                    <td>
                                                        <input
                                                            name="qty"
                                                            type="number"
                                                            value={itemRow.qty}
                                                            onChange={(e) => this.dynamicInputHandlerByKey(e, itemKey, 'inventoryTransferItemRows',() => {
                                                                let inventoryTransferItemRows = this.state.inventoryTransferItemRows;
                                                                
                                                                let selectedBatchList = inventoryTransferItemRows[itemKey].selected_batch_list || [];
                                                              
                                                                  let row                  =      {...inventoryTransferItemRows[itemKey],
                                                                    selected_batch_list  :        selectedBatchList.map(batchItem => {return { ...batchItem, qty: parseFloat(e?.target?.value) };})
                                                                };
                                                                inventoryTransferItemRows[itemKey]            =   row;
                                                                let allInventoryTransferItemRows        =       inventoryTransferItemRows.filter(i => i?.item ? true : false)
                                                                
                                                                this.setState({ inventoryTransferItemRows: allInventoryTransferItemRows })
                                                                
                                                            })}
                                                            className="form-control text-end"
                                                            placeholder="Qty"
                                                            required={true}
                                                            min={.01}
                                                             max={max_qty}
                                                            disabled={this.state.track_batch_expiry == 'Y' && itemRow && itemRow.current_stocks && itemRow.current_stocks.length > 0 ? true : false}
                                                            step=".01"
                                                        />
                                                        <span className="text-helping input-group-text text-end pr0">{item?.measuring_unit?.name ||  this.state.inventoryTransferItemRows[itemKey].measuring_unit}</span>
                                                       
                                                      <div>
                                                        {item.category == "services" ? null :
                                                         <small className={['my-1', (itemRow.qty > (itemRow.current_stocks && itemRow.current_stocks.length > 0 ? itemRow.current_stocks.reduce((sum, a) => sum + Number(a.free_qty), 0) : 0)) ? 'text-danger' : ''].join(' ')}>
                                                                        Stock In Hand: <b>{itemRow.current_stocks && itemRow.current_stocks.length > 0 ? itemRow.current_stocks.reduce((sum, a) => sum + Number(a.stock.qty), 0)  : "Nil"} </b> <br />
                                                                        Free Stock:  <b> {itemRow.current_stocks && itemRow.current_stocks.length > 0 ? itemRow.current_stocks.reduce((sum, a) => sum + Number(a.stock.free_qty), 0)  : "Nil"} </b> <br />
                                                                    </small>
                                                                   }
                                                          
                                                      </div>
                                                        
                                                    </td>
                                                    
                                                    <td>
                                                        <TapInputNumber
                                                            name="rate"
                                                            value={Number.isFinite(Number(itemRow.rate)) ? Number(itemRow.rate) : 0}
                                                            onChange={(e) => this.dynamicInputHandlerByKey(null, itemKey, 'inventoryTransferItemRows',null,'rate',e)}
                                                            placeholder="Unit Rate"
                                                            required={true}
                                                            min={0}
                                                             disabled={itemRow?.item?.category == "goods" && this.state.isc_item_weighted_average_cost == 'Y' ? true : false}
                                                        />
                                                    </td>
                                                    <td className='text-end rightSelectText'>
                                                        <TapSelect
                                                            changeEvent={(selectedOption, e) => {
                                                                this.dynamicInputHandlerByKeyNameVal(selectedOption.value, 'gst', itemKey, 'inventoryTransferItemRows')
                                                            }}
                                                            options={this.state.allGstSlabs}
                                                            isSearchable={false}
                                                            value={this.state.allGstSlabs.find(s => s.value == this.state.inventoryTransferItemRows[itemKey].gst)}
                                                            placeholder="GST"
                                                        />
                                                        {this.state.dispatchingWarehouseDetail && this.state.dispatchingWarehouseDetail.gstin
                                                            ? item ? <span className="text-helping input-group-text text-end pr0">{this.state.gstTypeName}</span> : null
                                                            : <div className='text-center'>NA <sup className='text-danger'>#</sup></div>}
                                                    </td>
                                                    <td className="pt-4 text-end">{(itemRow.rate * itemRow.qty).toFixed(2)} </td>
                                                </Ax>)}
                                    </Ax>
                                    : <Ax>
                                        <td className="align-middle">
                                            <InputItemSearch
                                                needIndent={'Y'}
                                                changeEvent={(selectedOption) => {
                                                    this.onItemSelect(selectedOption, itemKey);
                                                }}
                                                only_stocked_item={this.state.only_stocked_item}
                                                only_active_item='Y'
                                                warehouse_id={this.state.addInventoryTransferForm.warehouse_from}
                                                need_weighted_average_cost={this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N'}
                                                current_stock={'Y'}
                                                indent_exclude_warehouse_id={this.state.addInventoryTransferForm.warehouse_from}
                                                indent_warehouse_id={this.state.addInventoryTransferForm.warehouse_to}
                                                stock_warehouse_ids={[this.state.addInventoryTransferForm.warehouse_from]}
                                            />
                                        </td>
                                        <td colSpan={this.state.track_batch_expiry == 'Y' ? 6 : 5}></td>
                                    </Ax>
                                )}
                                <td className="text-center align-middle">
                                    {this.state.inventoryTransferItemRows.length > 1
                                        ? <a href="#" onClick={() => this.removeItemRow(itemKey)}>
                                            <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="" />
                                        </a>
                                        : null
                                    }
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table> 
                
            </div>
            <div className="col-sm-12 ">
            <div className='text-xs form-text'>#BNA : Batch Not Available</div>
                {this.state.addInventoryTransferForm.fullfill_purchase_qty == 'N' &&  <div className='text-end'>
                     {this.state.addInventoryTransferForm && this.state.addInventoryTransferForm.warehouse_from && this.state.addInventoryTransferForm.warehouse_to && <button type='button' onClick={() => {this.setState({showItemSearchModal : false},() => this.itemSearchModalInit())}} className="btn btn-link text-decoration-none ms-2">
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faSearch} /> Search Item
                    </button>}
                    {this.props?.permissions?.includes('isc-item-add') && <button type='button' onClick={() => {this.setState({showItemAddModal : false},() => this.addItemModalInit())}} className="btn btn-link text-decoration-none ms-3">
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Item
                    </button>}
                    <button type='button' onClick={this.addNewItemRow} className="btn btn-link text-decoration-none ms-3">
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row
                    </button>
                    <button type='button' disabled={this.state.addInventoryTransferForm.warehouse_from == null || this.state.addInventoryTransferForm.warehouse_to == null} onClick={this.transferBulkUploadModalInit} className="btn btn-link text-decoration-none ms-3">
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row Through Excel
                    </button>
                </div>}
            </div>
            <div className="col-sm-12">
                <div className="row">
                    <div className="col-sm-8">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value={this.state.only_stocked_item == "Y" ? "N" : "Y"}
                                checked={this.state.only_stocked_item == "Y"}
                                onChange={(e) => { this.setState({ only_stocked_item: e.target.value, }); }}
                                id="onlyStockedItem"
                            />
                            <label className="form-check-label" htmlFor="onlyStockedItem">
                                Show only those items that are available in the selected warehouse
                            </label>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>)
    }

    isStockChecked = (stock) => {
        if (stock.isDefaultChecked) return true;

        const row = this.state.inventoryTransferItemRows[this.state.selectedItemRow];
        if (!row || !row.selected_batch_list) return false;

        return row.selected_batch_list.some(b =>
            b.batch_number === stock.stock.batch_number &&
            b.expiry_date === stock.stock.expiry_date
        );
    };

    selectItemBatchModalJsx = () => {
    return (
        <div className="modal fade" id="selectItemBatchModal" tabIndex="-1">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="selectItemBatchModalLabel">Select Batch Number & Expiry Date</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className='p-1 bg-light border-bottom'>
                        <table className='table table-sm mb-0 table-borderless text-sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: "26%" }}> Item Name (Code)   </td>
                                    <th>{this.state.selectedItemData ? `${this.state.selectedItemData.name} (${this.state.selectedItemData.item_code})` : "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}> Dispatching Warehouse   </td>
                                    <th>{this.state.dispatchingWarehouseDetail ? `${this.state.dispatchingWarehouseDetail.name}` : "-"}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <form onSubmit={this.submitBatchFormSubmit} id="selectItemBatchForm">
                        <div className="modal-body">
                            <table className="table table-bordered table-fixed  bg-white table-sm">
                                <thead className="table-secondary" >
                                    <tr>
                                        <th scope="col" style={{ width: "5%" }} className="text-center">
                                            <input 
                                                type="checkbox"  
                                                onChange={this.checkAllBatchList}  
                                                id="all_batch_list_check"  
                                                ref={el => {
                                                    // Initialize checkbox state
                                                    if (el) {
                                                        setTimeout(() => {
                                                            this.updateSelectAllCheckbox();
                                                        }, 0);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th scope="col" style={{ width: "15%" }}>Batch Number</th>
                                        <th scope="col" style={{ width: "13%" }}> Expiry date</th>
                                        <th scope="col" style={{ width: "10%" }} className="text-end">Total Qty</th>
                                        <th scope="col" style={{ width: "10%" }} className="text-end">Allocated</th>
                                        <th scope="col" style={{ width: "10%" }} className="text-end">On-hold</th>
                                        <th scope="col" style={{ width: "10%" }} className="text-end">InTransit</th>
                                        <th scope="col" style={{ width: "10%" }} className="text-end">Free Stock</th>
                                        <th scope="col" style={{ width: "10%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.selectedItemStocks && this.state.selectedItemStocks.length > 0
                                        ? this.state.selectedItemStocks.map((stockList, i) => {
                                            // Calculate free_qty the same way as in item row
                                            let total_qty = stockList.stock && stockList.stock.total_qty ? Number(stockList.stock.total_qty) : 0;
                                            let allocated_qty = stockList.stock && stockList.stock.allocated_qty ? Number(stockList.stock.allocated_qty) : 0;
                                            let on_hold_qty = stockList.stock && stockList.stock.on_hold ? Number(stockList.stock.on_hold) : 0;
                                            let intransit_qty = stockList.stock && stockList.stock.intransit ? Number(stockList.stock.intransit) : 0;
                                            
                                            // Calculate free_qty: total - allocated - on_hold - intransit
                                            let free_qty = total_qty - allocated_qty - on_hold_qty - intransit_qty;
                                           
                                            // Adjust for edit mode if needed
                                            if (this.state.inventoryData && stockList.stock) {
                                                // In edit mode, we need to add back the selected quantity
                                                const selectedBatch = this.state.inventoryTransferItemRows[this.state.selectedItemRow]?.selected_batch_list?.find(
                                                    b => b.batch_number === stockList.stock.batch_number && 
                                                         b.expiry_date === stockList.stock.expiry_date
                                                );
                                                
                                                if (selectedBatch && selectedBatch.qty) {
                                                    free_qty += Number(selectedBatch.qty);
                                                    total_qty += Number(selectedBatch.qty);
                                                }
                                           
                                            }
                                            
                                            return (
                                                <tr key={i}>
                                                    <td className='text-center'>
                                                        <input
                                                            type="checkbox"
                                                            className="batch_expiry_checkbox"
                                                            name="batch_number"
                                                            value={stockList.stock.batch_number}
                                                            data-expiry_date={stockList.stock.expiry_date}
                                                            data-batch_number={stockList.stock.batch_number}
                                                            data-amount={stockList.stock.amount}
                                                            defaultChecked={stockList.isChecked || false}
                                                            onChange={() => setTimeout(this.updateSelectAllCheckbox, 0)}
                                                        />
                                                    </td>
                                                    <td>{stockList.stock && stockList.stock.batch_number ? stockList.stock.batch_number : "-"} </td>
                                                    <td>{stockList.stock && stockList.stock.expiry_date_display ? stockList.stock.expiry_date_display : "-"} </td>
                                                    <td className="text-end">{total_qty.toFixed(2)}</td>
                                                    <td className="text-end">{allocated_qty.toFixed(2)}</td>
                                                    <td className="text-end">{on_hold_qty.toFixed(2)}</td>
                                                    <td className="text-end">{intransit_qty.toFixed(2)}</td>
                                                    <td className="text-end">{free_qty.toFixed(2)}</td>
                                                    <td>
                                                        <TapInputNumber
                                                            className='form-control form-control-sm text-end'
                                                            placeholder='Qty'
                                                            name="new_qty"
                                                            value={stockList.new_qty}
                                                            onChange={(e) => {
                                                                this.state.selectedItemStocks[i] = { ...stockList, new_qty: e };
                                                                this.dynamicInputHandlerByKeyNameVal(e, 'new_qty', i, 'selectedItemStocks');
                                                            }}
                                                            max={free_qty}
                                                            step=".01" 
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        : <tr><td className='text-center' colSpan={9}>No Record</td></tr>
                                    }
                                </tbody>
                            </table>
                            
                          
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}


      pickIndentItemModalJsx                             =   ()  =>  {
        return (
            <div className="modal fade" id="pickIndentItemModal" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="pickIndentItemModalLabel">Pick Item from Approved Indent</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "26%" }}> Receiving Warehouse   </td>
                                        <th>{this.state.receivingWarehouseDetail ? `${this.state.receivingWarehouseDetail.name}` : "-"}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "26%" }}> Dispatching Warehouse   </td>
                                        <th>{this.state.dispatchingWarehouseDetail ? `${this.state.dispatchingWarehouseDetail.name}` : "-"}</th>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <form onSubmit={this.submitPickIndentFormSubmit} id="submitPickIndentForm">
                            <div className="modal-body">
                                <table className="table table-bordered table-sm align-middle bg-white my-2">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th className="text-center" style={{ width: "5%" }}><input type="checkbox" onChange={this.checkAllIndentItemList} id="all_indent_list_check" /></th>
                                            <th className="text-center" style={{ width: "10%" }}>Date of Transaction</th>
                                            <th className="text-center" style={{ width: "10%" }}>Transaction ID</th>
                                            <th style={{ width: "20%" }}>Item Name</th>
                                            <th style={{ width: "15%" }}>Item Code </th>
                                            <th className='text-end' style={{ width: "8%" }}>Pending {this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y' ? "Purchase" : null} Indent</th>
                                            <th className='text-end' style={{ width: "8%" }}>Freestock</th>
                                            {/* <th className='text-end' style={{ width: "8%" }}>Fullfill Qty</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* {this.state.approved_indent_listing
                                            ? (<tr><td colSpan="9" className="text-center"><Loader /></td></tr>)
                                            : */}
                                            {this.state.indent_listing && this.state.indent_listing.length > 0
                                                ? (this.state.indent_listing.map((rowData, k) => {
                                                    return (<tr key={k}>
                                                        <td className='text-center'>
                                                            <input
                                                                type='checkbox'
                                                                name="indent"
                                                                value={rowData.transaction_id}
                                                                data-itemId={rowData?.item?.id}
                                                                // checked={this.state.inventoryTransferItemRows.find(element => {
                                                                //     if (element?.indent_id == rowData.transaction_id && element?.item?.id == rowData?.item?.id) {
                                                                //         return true;
                                                                //     } else {
                                                                //         return false;
                                                                //     }
                                                                // })}
                                                               
                                                                className="indent_list_id_checkbox"
                                                                disabled={this.state.inventoryTransferItemRows.find(element => {
                                                                    if (element?.indent_id == rowData.transaction_id && element?.item?.id == rowData?.item?.id) {
                                                                        return true;
                                                                    } else {
                                                                        return false;
                                                                    }
                                                                })}
                                                            />
                                                        </td>
                                                        <td className='text-center' >{rowData.transaction_date_display ? rowData.transaction_date_display : "-"}</td>
                                                        <td className='text-center'>{rowData.transaction_id ? rowData.transaction_id : "-"}</td>
                                                        <td>{rowData.item && rowData.item.name ? rowData.item.name : "-"}</td>
                                                        <td>{rowData.item && rowData.item.item_code ? rowData.item.item_code : "-"}</td>
                                                        <td className='text-end'>{rowData.indent_qty && this.state.addInventoryTransferForm.fullfill_purchase_qty == 'N'  ? <NumberFormatter number={rowData.indent_qty} precision={2} />   :  rowData.purchase_qty ? <NumberFormatter number={rowData.purchase_qty} precision={2} /> :  0}</td>
                                                        <td className='text-end'>{rowData.dispatching_warehouse_free_stock ? <NumberFormatter number={rowData.dispatching_warehouse_free_stock} precision={2} />  : 0}</td>
                                                        {/* <td>
                                                            <input name="dispatching_fullfill_qty"
                                                                type="number"
                                                                value={this.state.indent_listing[k]?.dispatching_fullfill_qty}
                                                                onChange={(e) => this.dynamicInputHandlerByKey(e, k, 'dispatching_fullfill_qty')}
                                                                className="form-control text-end"
                                                                autoComplete="off"
                                                                placeholder="FullFill Qty"
                                                            // max={i.pending_qty}
                                                            />
                                                        </td> */}

                                                    </tr>);
                                                })
                                                )
                                                : !this.state.approved_indent_listing ?  (<tr><td className="text-center" colSpan={8}>No Record Found</td></tr>) : null
                                        }

                                    </tbody>
                                </table>
                                   {this.state.approved_indent_listing
                                            ? (<div className="text-center"><Loader /></div>)
                                            :null}

                                <div className='text-end mt-1 mb-5'>
                                    {this.state.indnetListingMeta && this.state.indnetListingMeta.current_page < this.state.indnetListingMeta.last_page
                                        ? <button type="button" className="btn btn-secondary me-3 " style={{ lineHeight: "6.3px!important", height: "27px" }} onClick={() => this.loadMoreList()} >Load More</button>
                                        : null}
                                </div>
                                {/* <DisplayListPagination
                                    meta={this.state.indnetListingMeta}
                                    onPageChange={(e) => this.getAllApprovedIndentItemList(e.selected + 1)}
                                /> */}

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    viewIndentDetailModalJsx                             =   ()  =>  {
        let indent = this.state.indentDetail;
        return (
            <div className="modal fade" id="viewIndentDetailModal" tabIndex="-1">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewIndentDetailModalLabel">Indent : {this.state.indentTransId ? this.state.indentTransId  : "-"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            {!this.state.indent_detail_loading
                                ? (<Ax>
                                    {indent
                                        ?
                                        <div>
                                            <table className="table table-bordered bg-white" >
                                                <thead className="table-secondary">
                                                    <tr>
                                                        <th style={{ width: "33%" }}>ID</th>
                                                        <th style={{ width: "33%" }}>Date</th>
                                                        <th style={{ width: "33%" }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td scope="col">{indent.transaction_id ? indent.transaction_id : "-"}</td>
                                                        <td scope="col">{indent.transaction_date_display ? indent.transaction_date_display : "-"}</td>
                                                        <td scope="col" className="align-middle">
                                                            {indent.status_data ? indent.status_data.name : ''}
                                                        </td>  </tr>
                                                </tbody>
                                            </table>
                                            <table className="table table-hover table-bordered  table-responsive bg-white mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: "33%" }} >Warehouse</td>
                                                        <td colSpan={2}>{indent.warehouse_detail ? <div><b>{indent.warehouse_detail.name} ({indent.warehouse_detail.code})</b> <br />
                                                            {indent.warehouse_detail ?
                                                                <div className='pt-1'>Address : {indent.warehouse_detail.address1 ? indent.warehouse_detail.address1 + ", " : ""}
                                                                    {indent.warehouse_detail.address2 ? indent.warehouse_detail.address2 + ", " : ""}
                                                                    {indent.warehouse_detail.landmark ? indent.warehouse_detail.landmark + ", " : ""}
                                                                    {indent.warehouse_detail.city ? indent.warehouse_detail.city + ". " : "-"} <br />
                                                                    State : <b>{indent.warehouse_detail.state_name}</b> <br />
                                                                    GSTIN  : {indent.warehouse_detail.gstin ? indent.warehouse_detail.gstin : "-"} <br />
                                                                </div> : "-"}</div> : "-"} <br />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td scope="col">Title</td>
                                                        <th scope="col">{indent.title ? indent.title : "-"}</th>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ width: "33%" }} >Indent For</td>
                                                        <th>{indent.indent_for && indent.indent_for == "asset" ? "Asset" : indent.indent_for && indent.indent_for == "workstation" ? "Workstation" : indent.indent_for && indent.indent_for == "employee" ? "Employee" : "-"} </th>
                                                    </tr>
                                                    {indent.indent_for ?
                                                        <tr>
                                                            <td style={{ width: "33%" }} >{indent.indent_for && indent.indent_for == "asset" ? "Asset" : indent.indent_for && indent.indent_for == "workstation" ? "Workstation" : indent.indent_for && indent.indent_for == "employee" ? "Employee" : "null"}</td>
                                                            <th>
                                                                {indent.indent_for == "asset" && indent.assetProfile ? indent.assetProfile.name : indent.indent_for == "workstation" && indent.workstation ? indent.workstation.workstation_name : indent.indent_for == "employee" && indent.employee ? indent.employee.name : "-"}
                                                            </th>
                                                        </tr> : null}
                                                    {indent.additional_attributes_data && indent.additional_attributes_data.length > 0
                                                        ? indent.additional_attributes_data.map((attr) => {
                                                            return (<tr key={attr.key}>
                                                                <td scope="col" className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                                                <th scope="col">{attr.value ? attr.value : "-"}</th>
                                                            </tr>)
                                                        }) : null}
                                                </tbody>
                                            </table>
                                            <table className="table  table-sm table-bordered table-responsive bg-white my-3" id="dataTable">
                                                <thead className="table-secondary">
                                                    <tr className="text-end">
                                                        <th scope="col" style={{ width: "5%" }} className="text-center"><input type='checkbox' onChange={this.checkAllItem} id="all_check_indent" /></th>
                                                        <th scope="col" className="text-center" style={{ width: "31%" }}>Item Details</th>
                                                        <th scope="col" className="text-center" style={{ width: "8%" }}>Indent Qty</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Fullfilled</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Pur. Req</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>PO</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Purchase</th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>In Transit </th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Cancelled  </th>
                                                        <th scope="col" className="text-end" style={{ width: "8%" }}>Pending </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        indent && indent?.items && indent?.items?.length > 0 ? indent?.items?.map((i, k) => {
                                                            return (<tr key={k} className="text-end">
                                                                <td className='text-center'>
                                                                    <input
                                                                        type='checkbox'
                                                                        name="foo"
                                                                        value={i?.itemData?.id}
                                                                        data-pendingQty={i.pending_qty}
                                                                        className="indent_item_id_checkbox"
                                                                        data-warehouseId={indent.warehouse_id}
                                                                        data-itemData={i?.itemData}
                                                                        data-transactionId={indent.transaction_id}
                                                                        data-statusLevel={indent.status_data && indent.status_data.level}
                                                                        data-statusIds={indent.status_data && indent.status_data.id}
                                                                    />
                                                                </td>
                                                                <td className="text-start">{i.itemData ? <div className='row'>
                                                                    <div className='col-sm-9'>
                                                                        <ItemViewInList item={i.itemData} remark={i.remark} viewItemModal={() => this.viewItemModalInit(i.itemData)} />
                                                                    </div>

                                                                </div> : null}</td>
                                                                <td>{i.indent_qty ? i.indent_qty : 0}</td>
                                                                <td>{i.fullfilled_qty ? i.fullfilled_qty : 0}</td>
                                                                <td>{i.req_qty ? i.req_qty : 0}</td>
                                                                <td>{i.po_qty ? i.po_qty : 0}</td>
                                                                <td>{i.purchase_qty ? i.purchase_qty : 0}</td>
                                                                <td>{i.transit_qty ? i.transit_qty : 0}</td>
                                                                <td>{i.cancelled_qty ? i.cancelled_qty : 0}</td>
                                                                <td>{i.pending_qty ? i.pending_qty : 0}</td>
                                                            </tr>);


                                                        })
                                                            : <tr ><td className='text-center' colSpan={10}>No Record</td></tr>
                                                    }

                                                </tbody>
                                            </table>
                                            <div className="row align-items-center ">
                                                <div className="col-sm-6">
                                                    <label htmlFor="notes" className="form-label">Notes</label>
                                                    <div>{indent.notes ? indent.notes : "-"}</div>

                                                </div>
                                                <div className=" col-sm-6">

                                                    <table className="table  table-borderless">
                                                        <tbody>

                                                            <tr className="subtotal_bg_color">
                                                                <th>Total Quantity</th>
                                                                <td className='float-end'>{indent.total_qty ? indent.total_qty : 0} </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>
                                        : null}
                                </Ax>)
                                : <Loader />}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    transferBulkUploadModalJsx = () => {
        return (
            <div className="modal fade" id="transferBulkUploadModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemBulkUploadModalLabel">
                                Bulk Add Items
                            </h5>
                            <button
                                type="button"
                                disabled={this.state.transferBulkUploadFormSubmiting}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <form
                            onSubmit={this.transferBulkUploadFormSubmit}
                            id="transferBulkUploadForm"
                            method="post"
                            encType="multipart/form-data"
                        >
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-12">
                                        <input
                                            name="document"
                                            id="addTransferFileSelector"
                                            type="file"
                                            className="form-control"
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Excel Sheet with Extention xls,xlm,xlsx,ods Allowed
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Miximum 100 MB Size of Excel Sheet Allowed
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div>
                                    <a
                                        type="button"
                                        className="float-left"
                                        href="#"
                                        onClick={this.downloadSampleFile}
                                    >
                                        Download Sample File
                                    </a>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        disabled={this.state.transferBulkUploadFormSubmiting}
                                        className="btn btn-secondary mx-2"
                                        data-bs-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={this.state.transferBulkUploadFormSubmiting}
                                        className="btn btn-primary"
                                    >
                                        Submit{" "}
                                        {this.state.transferBulkUploadFormSubmiting ? (
                                            <tapIcon.FontAwesomeIcon
                                                icon={tapIcon.faSyncAlt}
                                                className="fa-spin"
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    receivingWarehouseAddressModalJsx = () => {
        return (
            <div className="modal fade" id="receivingWarehouseAddressModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="receivingWarehouseDetailsModalLabel">
                                Receiving Warehouse Ship to Address Lists
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => this.setState({ searchReceivingWarehouseAddress: "" })}
                            ></button>
                        </div>

                        {!this.state.receiving_address_loading ? (
                            this.state.receivingWarehouseAddressList ? (
                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={(e) =>
                                                    this.setState({
                                                        searchReceivingWarehouseAddress: e.target.value,
                                                    })
                                                }
                                                placeholder="Search Address, Pin Code, GSTIN"
                                                value={this.state.searchReceivingWarehouseAddress}
                                            />
                                        </div>
                                        <div className="col-sm-2 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-lg"
                                                onClick={() => {
                                                    this.getReceivingWarehouseAddressList(
                                                        this.state.addInventoryTransferForm.warehouse_to,
                                                        1
                                                    );
                                                    this.setState({ clearReceivingSearchAddress: false });
                                                }}
                                                disabled={this.state.searchReceivingWarehouseAddress.length === 0}
                                            >
                                                <tapIcon.FontAwesomeIcon icon={tapIcon.faSearch} />
                                            </button>
                                        </div>
                                        <div className="col-sm-2">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-lg"
                                                onClick={() =>
                                                    this.setState({ searchReceivingWarehouseAddress: "" }, () => {
                                                        this.getReceivingWarehouseAddressList(
                                                            this.state.addInventoryTransferForm.warehouse_to,
                                                            1
                                                        );
                                                        this.setState({ clearReceivingSearchAddress: true });
                                                    })
                                                }
                                                disabled={this.state.searchReceivingWarehouseAddress.length === 0 || this.state.clearReceivingSearchAddress}
                                            >
                                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" />
                                            </button>
                                        </div>
                                    </div>
                                    <table className="table table-hover table-bordered">
                                        <tbody>
                                          
                                            {this.state.receivingWarehouseAddressList.length > 0
                                                ? this.state.receivingWarehouseAddressList.map((a, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                <div className="py-1">
                                                                    <b> {a.label ? a.label  : ""}</b><br/>
                                                                    Address: <b>
                                                                        {a.address1 ? a.address1 + ", " : ""}
                                                                        {a.address2 ? a.address2 + ", " : ""}
                                                                        {a.landmark ? a.landmark + ", " : ""}
                                                                        {a.city ? a.city : ""}
                                                                    </b>
                                                                </div>
                                                                <div className="py-1">
                                                                    District, State & Pincode: <b>
                                                                        {a.district_name ? a.district_name + ", " : ""}
                                                                        {a.state_name ? a.state_name : ""}
                                                                        {a.pincode ? " & " + a.pincode : ""}
                                                                    </b>
                                                                </div>
                                                                <div className="py-1">
                                                                    GSTIN: <b>{a.gstin ? a.gstin : ""}</b>
                                                                </div>
                                                            </td>
                                                            <td className="text-center" style={{ width: "15%" }}>
                                                                {this.state.selectedShippingAddress &&
                                                                    a.id == this.state.selectedShippingAddress.id ? (
                                                                    <button type="button" className="btn btn-secondary">
                                                                        Selected
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        onClick={() => {
                                                                            this.changeReceivingWarehouseAddressHandler(a.id);
                                                                            this.receivingWarehouseAddressModal.hide();
                                                                        }}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                : null}
                                        </tbody>
                                    </table>
                                    <DisplayListPagination
                                        meta={this.state.receivingWarehouseListingMeta}
                                        onPageChange={(e) =>
                                            this.getReceivingWarehouseAddressList(
                                                this.state.addInventoryTransferForm.warehouse_to,
                                                e.selected + 1
                                            )
                                        }
                                    />
                                </div>
                            ) : null
                        ) : (
                            <Loader />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render              =             ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>Inventory Transfer Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-sm-12">
                    <h3>{this.state.inventoryData ? "Edit" : "New"} {this.state.addInventoryTransferForm.fullfill_purchase_qty == 'Y' && "Purchase"} Inventory Transfer {this.state.inventoryData ? <span> of Transaction ID : {this.state.inventoryData.transaction_id}</span> : null}</h3>
                    <div className="text-end mt15">
                        <button onClick={this.closeEvent} disabled={this.state.saveFormSubmitting ? true : false} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Requisition" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-sm-12 pl4">
                        {this.saveInventoryTransferFormJsx()}
                    </div>
                </div>
            </div>
            {this.selectItemBatchModalJsx()}
            {this.pickIndentItemModalJsx()}
            {this.viewIndentDetailModalJsx()}
            {this.transferBulkUploadModalJsx()}
            {this.receivingWarehouseAddressModalJsx()}
            <ItemDetailsModal ref={this.itemDetailsRef} /> 
            {this.state.showItemAddModal && <AddItemModal parentProps={this.props} ref={this.addItemModalRef} />}
            {this.state.showItemEditModal && <ItemEditModal parentProps={this.props} ref={this.editItemModalRef} afterSubmitItem={this.submitEditItem} />}
            {this.state.showItemSearchModal && <ItemSearchModal ref={this.itemSearchRef}
                            afterSelectingItems={(selectedItems) => {
                                this.addItemsfromSearch(selectedItems);
                            }}
                            need_weighted_average_cost={this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N'}
                            current_stock={'Y'}
                            warehouse_id={this.state.addInventoryTransferForm.warehouse_from}
                            indent_warehouse_id={this.state.addInventoryTransferForm.warehouse_to}
                        />}
            {
                this.state.dispatchAddressModalHandle &&
                <ChangeWarehouseAddressModal ref={this.changeWarehouseAddressRef} warehouseDetail={(address, type) => this.handleDispatchWarehouseAddress(address, type)} sameWarehouseAddress={this.state.sameDispatchWarehouseAddress} selecteSameAddress={this.state.selectDispatchAddress ? false : true} selectedShippingAddress={this.state.selectDispatchAddress}/>
            }
            {
                this.state.receivingAddressModalHandle && 
                <ChangeWarehouseAddressModal ref={this.changeWarehouseAddressRef} warehouseDetail={(address, type) => this.handleReceivingWarehouseAddress(address, type)} sameWarehouseAddress={this.state.sameReceivingWarehouseAddress} selecteSameAddress={this.state.selectReceivingAddress ? false : true} selectedShippingAddress={this.state.selectReceivingAddress}/>
            }
            <InwardHistoryModal ref={this.inwardHistoryRef}/>
        </ApplicationLayout>);
    }

    handleDispatchWarehouseAddress = (address, type) => {
        if (type === 'same') {
            // Use warehouse main address (not a shipping address)
            this.setState({
                selectDispatchAddress: null,
                dispatchingWarehouseDetail: this.state.sameDispatchWarehouseAddress
            }, () => {
                // Update GST type
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
                const receiveState = this.state.receivingWarehouseDetail?.state_id;
                if (dispatchState === receiveState) {
                    this.setState({ gstTypeName: 'GST' });
                } else {
                    this.setState({ gstTypeName: 'IGST' });
                }
            });
        } else {
            // Use selected shipping address from modal
            this.setState({
                selectDispatchAddress: address,
                dispatchingWarehouseDetail: address
            }, () => {
                // Update GST type
                const dispatchState = address?.state_id;
                const receiveState = this.state.receivingWarehouseDetail?.state_id;
                if (dispatchState === receiveState) {
                    this.setState({ gstTypeName: 'GST' });
                } else {
                    this.setState({ gstTypeName: 'IGST' });
                }
            });
        }
    }

    handleReceivingWarehouseAddress = (address, type) => {
        if (type === 'same') {
            this.setState({
                selectReceivingAddress: null,
                receivingWarehouseDetail: this.state.sameReceivingWarehouseAddress
            }, () => {
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
                const receiveState = this.state.receivingWarehouseDetail?.state_id;
                if (dispatchState === receiveState) {
                    this.setState({ gstTypeName: 'GST' })
                } else {
                    this.setState({ gstTypeName: 'IGST' })
                }
            });
        } else {
            this.setState({
                selectReceivingAddress: address,
                receivingWarehouseDetail: address
            }, () => {
                const dispatchState = this.state.dispatchingWarehouseDetail?.state_id;
                const receiveState = address?.state_id;
                if (dispatchState === receiveState) {
                    this.setState({ gstTypeName: 'GST' })
                } else {
                    this.setState({ gstTypeName: 'IGST' })
                }
            });
        }
    }

}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
         isc_setting             :   state.app && state.app.isc_setting ? state.app.isc_setting : null,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        permissions              :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(InventoryTransferAdd);